import { useTranslation } from 'react-i18next'
import { localizedName } from '../utils/localizedName'
import SignaturePad from '../components/SignaturePad'
import { useEffect, useRef, useState } from 'react'
import {
  Box, Text, Button, Table, Badge, Group, Modal, Stack,
  TextInput, Textarea, Select, Center, Loader, SimpleGrid,
  Image, FileButton, ScrollArea, Divider, ActionIcon, Tooltip, Paper,
  Alert, Anchor, Timeline, Card, Menu, Drawer, Indicator,
} from '@mantine/core'
import { useDisclosure, useMediaQuery } from '@mantine/hooks'
import { useBreakpoint } from '../hooks/useBreakpoint'
import { notifications } from '@mantine/notifications'
import { useAuth } from '../hooks/useAuth'
import {
  IconPlus, IconPrinter, IconPhoto, IconHistory,
  IconX, IconEdit, IconBan, IconCheck, IconArrowBack, IconUser, IconInfoCircle, IconSearch, IconMailForward, IconRefresh, IconDotsVertical, IconFilter,
} from '@tabler/icons-react'
import {
  getAssets, createHandover, updateHandover, receiveHandover,
  cancelHandover, approveHandover, rejectHandover, getHandovers, getHandover, getLocations, getCategories,
  getRecipients, getPositions, getDepartments, getModels, scanLookupAsset,
  downloadHandoverPdf, updateHandoverAccessories, resendHandoverConfirmEmail, getHandoverHistory,
} from '../api/client'
import { modals } from '@mantine/modals'
import api from '../api/client'
import AssetQuickView from '../components/assets/AssetQuickView'
import ImageLightbox, { useLightbox } from '../components/ImageLightbox'
import jsPDF from 'jspdf'
import { drawHeader, urlToBase64, drawSection, drawRow2, drawRow, drawFooter, registerThaiFont, PDF_FONT , openPdfInNewTab} from '../assets/pdfHelper'

const LOGO_B64 = 'data:image/png;base64,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';;

// ─── Signature Pad ────────────────────────────────────────────────────────────



// ─── PDF Generate (jsPDF) ─────────────────────────────────────────────────────

async function generateHandoverPDF(h: any, logoB64?: string | null, companyName?: string | null) {
  const pdf = new jsPDF({ orientation: 'p', unit: 'mm', format: 'a4' })
  registerThaiFont(pdf)
  const W = 210, M = 15
  const today = h.handoverDate
    ? new Date(h.handoverDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })
    : new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })
  const ref = `HOV-${String(h.id ?? 0).padStart(5, '0')}`

  let y = await drawHeader(pdf, 'IT ASSET HANDOVER FORM', '(Equipment Handover & Receipt)', ref, today, logoB64, companyName ?? undefined)

  // ── Recipient Information ─────────────────────────────────────────────────
  y = drawSection(pdf, 'Recipient Information', y)
  y = drawRow2(pdf, 'Received By:', h.toUser ?? '—', 'From:', h.fromUser ?? '—', y)
  y = drawRow2(pdf, 'Position:', h.toPosition ?? '—', 'Department:', h.department ?? '—', y)
  y = drawRow2(pdf, 'Location:', h.location ?? '—', 'Date:', today, y)
  y += 2

  // ── Assets ────────────────────────────────────────────────────────────────
  y = drawSection(pdf, 'Assets Transferred', y)
  pdf.setFillColor(241, 245, 249)
  pdf.rect(M, y, W - M * 2, 7, 'F')
  pdf.setFont(PDF_FONT, 'bold'); pdf.setFontSize(8.5)
  const colX = [M, M + 10, M + 68, M + 120]
  pdf.text('No.', colX[0] + 2, y + 5)
  pdf.text('Name', colX[1] + 2, y + 5)
  pdf.text('Serial Number', colX[2] + 2, y + 5)
  pdf.text('Description', colX[3] + 2, y + 5)
  y += 9

  const assets = h.assets ?? []
  const minRows = Math.max(assets.length, 5)
  for (let i = 0; i < minRows; i++) {
    const a = assets[i]
    pdf.setFillColor(i % 2 === 0 ? 255 : 249, i % 2 === 0 ? 255 : 250, i % 2 === 0 ? 255 : 252)
    pdf.rect(M, y, W - M * 2, 8, 'F')
    pdf.setDrawColor(220, 220, 220); pdf.rect(M, y, W - M * 2, 8, 'S')
    if (a) {
      pdf.setFont(PDF_FONT, 'bold'); pdf.setFontSize(8.5)
      pdf.text(String(i + 1), colX[0] + 3, y + 5.5)
      pdf.text(pdf.splitTextToSize(a.name ?? '', 56)[0], colX[1] + 2, y + 5.5)
      pdf.setFont(PDF_FONT, 'normal')
      pdf.text(a.serialNumber ?? '—', colX[2] + 2, y + 5.5)
      pdf.text(pdf.splitTextToSize(a.category ?? '—', 42)[0], colX[3] + 2, y + 5.5)
    }
    y += 8
  }
  y += 4

  // ── Accessories ───────────────────────────────────────────────────────────
  if (h.accessories) {
    y = drawSection(pdf, 'อุปกรณ์เสริมที่ส่งมอบ', y)
    const accItems = parseAccessoriesFE(h.accessories)
    const accText = accItems.map((a: any) => {
      let line = a.name ?? a
      if (a.serialNumber) line += ` (S/N: ${a.serialNumber})`
      return line
    }).join('  |  ')
    pdf.setFont(PDF_FONT, 'normal'); pdf.setFontSize(9)
    const accLines = pdf.splitTextToSize(accText, W - M * 2 - 6)
    pdf.text(accLines, M + 3, y)
    y += accLines.length * 5.5 + 4
  }

  // ── Asset Condition ───────────────────────────────────────────────────────
  y = drawSection(pdf, 'สภาพอุปกรณ์ & การยืนยันรับมอบ', y)
  pdf.setFont(PDF_FONT, 'normal'); pdf.setFontSize(9)
  const condText = h.assetCondition || 'ข้าพเจ้าได้รับอุปกรณ์ตามรายการข้างต้นในสภาพดี และรับทราบว่าต้องดูแลรักษาและใช้งานอย่างถูกต้องเหมาะสม'
  const condLines = pdf.splitTextToSize(condText, W - M * 2 - 6)
  pdf.text(condLines, M + 3, y)
  y += condLines.length * 5.5 + 6

  // ── Signatures ────────────────────────────────────────────────────────────
  y = drawSection(pdf, 'Authorized Signatures', y)

  const sigW = (W - M * 2 - 10) / 2
  const sigH = 38
  const sigs = [
    { title: 'ลายเซ็นผู้ส่งมอบ', sub: '(IT Department / Asset Manager)' },
    { title: 'Receiver Signature', sub: '(Employee Receiving Asset)' },
  ]

  sigs.forEach((sig, i) => {
    const sx = M + i * (sigW + 10)
    pdf.setDrawColor(150, 150, 150); pdf.rect(sx, y, sigW, sigH)
    pdf.setFont(PDF_FONT, 'bold'); pdf.setFontSize(8)
    pdf.text(sig.title, sx + 3, y + 7)
    pdf.setFont(PDF_FONT, 'normal'); pdf.setFontSize(7.5)
    pdf.text(sig.sub, sx + 3, y + 12)
    // Signature image
    const sigData = i === 0 ? h.fromSignature : h.toSignature
    if (sigData) {
      try {
        const imgData = sigData.includes(',') ? sigData : `data:image/png;base64,${sigData}`
        pdf.addImage(imgData, 'PNG', sx + 3, y + 14, sigW * 0.55, 12)
      } catch (_) {}
    }
    pdf.setDrawColor(180, 180, 180)
    pdf.line(sx + 3, y + 28, sx + sigW - 3, y + 28)
    pdf.setFontSize(7); pdf.setFont(PDF_FONT, 'normal')
    pdf.text('Signature', sx + 3, y + 32)
    pdf.line(sx + 3, y + 35, sx + sigW - 3, y + 35)
    pdf.text(`Name: ${i === 0 ? (h.fromUser ?? '—') : (h.toUser ?? '—')}`, sx + 3, y + 37.5)
  })
  y += sigH + 6

  // Footer page 1
  drawFooter(pdf, ref, today)

  // ── PAGE 2: Return Record (if RETURNED) ──────────────────────────────────────
  if (h.status === 'RETURNED') {
    pdf.addPage()
    let ry = M
    ry = await drawHeader(pdf, 'IT ASSET HANDOVER FORM', '(Return Record)', ref, today, logoB64, companyName ?? undefined)

    // Dashed separator
    pdf.setDrawColor(200, 50, 50)
    pdf.setLineDashPattern([3, 2], 0)
    pdf.line(M, ry, W - M, ry)
    pdf.setLineDashPattern([], 0)
    ry += 6

    ry = drawSection(pdf, 'RETURN RECORD', ry)

    const returnDate = h.returnDate
      ? new Date(h.returnDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })
      : new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })

    const conditionLabel = h.returnCondition === 'good' ? 'Good'
      : h.returnCondition === 'repair' ? 'Needs Repair'
      : h.returnCondition === 'damaged' ? 'Damaged' : '—'

    ry = drawRow2(pdf, 'Return Date:', returnDate, 'Asset Condition:', conditionLabel, ry)
    ry = drawRow2(pdf,
      'Returned By:', h.returnReceiverName ?? '—',
      'Position:', h.returnReceiverPosition ?? '—', ry)

    if (h.returnAccessoriesStatus) {
      const accStatus = h.returnAccessoriesStatus === 'complete' ? 'Complete' : 'Incomplete / Missing'
      ry = drawRow2(pdf, 'Accessories:', accStatus,
        'Note:', h.returnAccessoriesNote ?? '—', ry)
    }
    if (h.returnNote) ry = drawRow(pdf, 'Remark:', h.returnNote, ry)
    ry += 4

    // Return signatures
    ry = drawSection(pdf, 'Return Signatures', ry)
    const retSigW = (W - M * 2 - 10) / 2
    const retSigH = 36
    const retSigs = [
      { title: 'Employee Returning Asset', sub: h.returnReceiverName ?? '—', sig: h.returnSignature },
    ]
    retSigs.forEach((sig, i) => {
      const sx = M + i * (retSigW + 10)
      pdf.setDrawColor(150, 150, 150); pdf.rect(sx, ry, retSigW, retSigH)
      pdf.setFont(PDF_FONT, 'bold'); pdf.setFontSize(8)
      pdf.text(sig.title, sx + 3, ry + 7)
      pdf.setFont(PDF_FONT, 'normal'); pdf.setFontSize(7.5)
      pdf.text(sig.sub, sx + 3, ry + 12)
      if (sig.sig) {
        try {
          const imgData = sig.sig.includes(',') ? sig.sig : `data:image/png;base64,${sig.sig}`
          pdf.addImage(imgData, 'PNG', sx + 3, ry + 13, retSigW * 0.5, 11)
        } catch (_) {}
      }
      pdf.setDrawColor(180, 180, 180)
      pdf.line(sx + 3, ry + 26, sx + retSigW - 3, ry + 26)
      pdf.setFontSize(7); pdf.setFont(PDF_FONT, 'normal')
      pdf.text('Signature', sx + 3, ry + 30)
      pdf.line(sx + 3, ry + 33, sx + retSigW - 3, ry + 33)
      pdf.text(`Asset Condition: ${conditionLabel}`, sx + 3, ry + 35.5)
    })

    drawFooter(pdf, ref, today)
  }

  // ── PAGE 3: Photos (only if there are actual photos) ────────────────────────
  const handoverPhotos: string[] = Array.isArray(h.photos) ? h.photos : []
  const returnPhotos   = parsePhotos(h.returnPhotos)

  if (handoverPhotos.length > 0 || returnPhotos.length > 0) {
    pdf.addPage()
    let py = M
    py = await drawHeader(pdf, 'IT ASSET HANDOVER FORM', '(Photo Documentation)', ref, today, logoB64, companyName ?? undefined)

    const addPhotoFit = async (src: string, x: number, y: number, maxW: number, maxH: number): Promise<number> => {
      try {
        let imgSrc = src.trim()
        if (imgSrc.startsWith('http')) {
          const res = await fetch(imgSrc)
          const blob = await res.blob()
          imgSrc = await new Promise<string>((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result as string)
            reader.onerror = reject
            reader.readAsDataURL(blob)
          })
        }
        const { w: nw, h: nh } = await new Promise<{w:number,h:number}>((res) => {
          const img = new window.Image()
          img.onload = () => res({w: img.width, h: img.height})
          img.onerror = () => res({w: 0, h: 0})
          img.src = imgSrc
        })
        const realW = nw || maxW; const realH = nh || maxH
        const ratio = Math.min(maxW / realW, maxH / realH)
        const w = realW * ratio; const hh = realH * ratio
        const offsetX = x + (maxW - w) / 2
        const fmt = imgSrc.includes('png') ? 'PNG' : 'JPEG'
        pdf.addImage(imgSrc, fmt, offsetX, y, w, hh)
        return hh
      } catch { return maxH }
    }

    const halfW = (W - M * 2 - 8) / 2
    const maxH  = 80
    py = drawSection(pdf, 'Photos at Handover', py)
    if (handoverPhotos.length > 0) {
      for (let i = 0; i < Math.min(handoverPhotos.length, 3); i++) {
        const x = M + (i % 2) * (halfW + 8)
        if (i % 2 === 0 && i > 0) py += maxH + 4
        await addPhotoFit(handoverPhotos[i], x, py, halfW, maxH)
        if (i % 2 === 1 || i === handoverPhotos.length - 1) py += maxH + 4
      }
    } else {
      pdf.setFont('helvetica', 'italic'); pdf.setFontSize(8); pdf.setTextColor(150,150,150)
      pdf.text('No photo attached', M + 3, py + 8)
      pdf.setTextColor(0,0,0); py += 16
    }

    if (returnPhotos.length > 0) {
      py = drawSection(pdf, 'Photos at Return', py)
      for (let i = 0; i < Math.min(returnPhotos.length, 3); i++) {
        const x = M + (i % 2) * (halfW + 8)
        if (i % 2 === 0 && i > 0) py += maxH + 4
        await addPhotoFit(returnPhotos[i], x, py, halfW, maxH)
        if (i % 2 === 1 || i === returnPhotos.length - 1) py += maxH + 4
      }
    }

    drawFooter(pdf, ref, today)
  }

  openPdfInNewTab(pdf, `${ref}.pdf`)
}

// ─── Status Badge ─────────────────────────────────────────────────────────────

const STATUS_COLOR: Record<string, string> = { PENDING_APPROVAL: 'orange', DRAFT: 'yellow', RECEIVED: 'teal', CANCELLED: 'gray', RETURNED: 'blue', REJECTED: 'red', REJECTED_BY_RECIPIENT: 'red' }

// ─── Default condition template ───────────────────────────────────────────────

// DEFAULT_CONDITION ใช้ i18n แทน — ดู t('handover.defaultConditionText')
const DEFAULT_CONDITION = ''

// ─── Empty form ───────────────────────────────────────────────────────────────

/** แปลง accessories กลับเป็น array มาตรฐาน — ใช้ logic เดียวกับฝั่ง backend (parseAccessories) */
function parseAccessoriesFE(raw: any): { name: string; serialNumber?: string; assetId?: number }[] {
  if (!raw) return []
  if (Array.isArray(raw)) return raw
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw)
      if (Array.isArray(parsed)) return parsed
      // ข้อมูลเก่าบางส่วนเก็บเป็น object เดี่ยว (ไม่ห่อ array) — เจอ bug จริงจากรูปที่ส่งมา
      if (parsed && typeof parsed === 'object' && parsed.name) return [parsed]
    } catch { /* ไม่ใช่ JSON — plain text เก่า */ }
    return raw.split('\n').map(line => ({ name: line.trim() })).filter(a => a.name)
  }
  return []
}

/**
 * แปลง returnPhotos กลับเป็น array ของ base64 data URL อย่างปลอดภัย — เดิมเก็บแบบ comma-joined string
 * ซึ่งพังเสมอเมื่อมีมากกว่า 1 รูป (base64 data URL มี comma อยู่ในตัวเองอยู่แล้วที่ "data:image/png;base64,")
 * พอ join ด้วย comma แล้ว split กลับ เลยแตกเป็นชิ้นผิดๆ ตอนนี้เก็บเป็น JSON string แทน ปลอดภัยแน่นอน
 * ข้อมูลเก่าที่เคย comma-joined ไว้กู้คืนไม่ได้แล้ว (fragment หายไปแล้วจริงๆ) แต่ไม่ควรทำให้หน้าเว็บพังไปด้วย
 */
function parsePhotos(raw: any): string[] {
  if (!raw) return []
  if (Array.isArray(raw)) return raw
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw)
      if (Array.isArray(parsed)) return parsed
    } catch { /* ข้อมูลเก่าแบบ comma-joined — กู้คืนแยกรูปไม่ได้แล้ว ปล่อยว่างไปเลยดีกว่าโชว์รูปพัง */ }
    return []
  }
  return []
}

const EMPTY_FORM = { assetIds: [] as number[], toUser: '', toEmail: '', toPosition: '', department: '', location: '', assetCondition: DEFAULT_CONDITION, accessories: [] as { name: string; serialNumber: string }[], note: '' }

// ─── Main Page ────────────────────────────────────────────────────────────────

export default function HandoverPage() {
  const { t, i18n } = useTranslation()
  const { isMobile, isTablet, isSmall } = useBreakpoint()
  const { roles, fullName, username, position: userPosition , companyLogoUrl, companyName} = useAuth()
  const canProcess = roles.includes('ADMIN') || roles.includes('ASSET_MANAGER')
  const [qvAsset, setQvAsset] = useState<any>(null)
  const [qvOpen, setQvOpen] = useState(false)
  const { lightbox, openLightbox, closeLightbox } = useLightbox()
  const openQv = (code: string) => scanLookupAsset(code).then(r => { if (r.data?.found) { setQvAsset(r.data); setQvOpen(true) } })
  const [handovers, setHandovers]       = useState<any[]>([])
  const [statusFilter, setStatusFilter] = useState<string>('ALL')
  const [assets, setAssets]             = useState<any[]>([])
  const [recipientFilter, setRecipientFilter] = useState<string | null>(null)
  // ── Filter bottom sheet (มือถือ) — เหมือน pattern เดียวกับ AssetsPage.tsx สำหรับตัวกรอง
  // ผู้รับ (สถานะควบคุมผ่านการ์ดสรุปยอดแยกต่างหาก ไม่ใช่ dropdown เลยไม่ต้องย้ายเข้าแผ่นนี้) ──
  const [filterSheetOpen, setFilterSheetOpen] = useState(false)
  const [draftRecipient, setDraftRecipient] = useState<string | null>(null)
  const openFilterSheet = () => { setDraftRecipient(recipientFilter); setFilterSheetOpen(true) }
  const applyFilterSheet = () => { setRecipientFilter(draftRecipient); setFilterSheetOpen(false) }
  const clearFilterSheet = () => setDraftRecipient(null)
  const [search, setSearch]             = useState('')
  const [locations, setLocations]       = useState<any[]>([])
  const [categories, setCategories]     = useState<any[]>([])
  const [recipients, setRecipients]     = useState<any[]>([])
  const [positions, setPositions]       = useState<any[]>([])
  const [departments, setDepartments]   = useState<any[]>([])
  const [categoryFilter, setCategoryFilter] = useState<string | null>(null)
  const [assetSearch, setAssetSearch]       = useState('')
  const [loading, setLoading]           = useState(true)
  const [saving, setSaving]             = useState(false)

  // Create / Edit modal
  const [opened, { open, close }]       = useDisclosure(false)
  const [editingId, setEditingId]       = useState<number | null>(null)
  const [modalKey, setModalKey]         = useState(0)  // increment to force Modal remount
  const [form, setForm]                 = useState({ ...EMPTY_FORM })
  const [fromSig, setFromSig]           = useState('')
  const [toSig, setToSig]               = useState('')
  const [photos, setPhotos]             = useState<string[]>([])

  // Approve (signature) modal
  const [sigOpened, { open: openSig, close: closeSig }] = useDisclosure(false)
  const [selectedHandover, setSelectedHandover] = useState<any>(null)
  const [receiveSig, setReceiveSig]             = useState('')
  const [approving, setApproving]               = useState(false)

  // Return modal
  const [returnOpened, { open: openReturn, close: closeReturn }] = useDisclosure(false)
  const [accOpened, { open: openAccModal, close: closeAccModal }] = useDisclosure(false)
  const [resendOpened, { open: openResend, close: closeResend }] = useDisclosure(false)
  const [resendTarget, setResendTarget] = useState<any>(null)
  const [resendEmail, setResendEmail] = useState('')
  const [resending, setResending] = useState(false)
  const [detailOpened, { open: openDetail, close: closeDetail }] = useDisclosure(false)
  const [detailTarget, setDetailTarget] = useState<any>(null)
  const [historyOpened, { open: openHistory, close: closeHistory }] = useDisclosure(false)
  const [historyTarget, setHistoryTarget] = useState<any>(null)
  const [historyData, setHistoryData] = useState<any[]>([])
  const [loadingHistory, setLoadingHistory] = useState(false)
  const [accTarget, setAccTarget] = useState<any>(null)
  const [accForm, setAccForm] = useState<{ accessories: any[]; note: string }>({ accessories: [], note: '' })
  const [replacements, setReplacements] = useState<{ oldAssetId: number; oldName: string; reason: string }[]>([])
  const [replaceOpened, setReplaceOpened] = useState(false)
  const [replaceTargetIdx, setReplaceTargetIdx] = useState<number | null>(null)
  const [replaceNewAssetId, setReplaceNewAssetId] = useState<string | null>(null)
  const [replaceReason, setReplaceReason] = useState('')
  const [accSaving, setAccSaving] = useState(false)
  const [returnTarget, setReturnTarget] = useState<any>(null)
  const [returning, setReturning]       = useState(false)
  const [returnForm, setReturnForm]     = useState({
    returnCondition: 'good',
    returnAccessoriesStatus: 'complete',
    returnAccessoriesNote: '',
    returnPhotos: [] as string[],
    returnReceiverName: '',
    returnReceiverPosition: '',
    returnLocation: '',
    returnNote: '',
    returnSignature: '',
  })
  const [returnSig, setReturnSig]       = useState('')
  const [itemResults, setItemResults] = useState<{ assetId: number; name: string; code: string; condition: string; note: string }[]>([])
  const [nonAssetResults, setNonAssetResults] = useState<{ name: string; condition: string; note: string }[]>([])

  // ─── Load ───────────────────────────────────────────────────────────────────

  const load = async () => {
    setLoading(true)
    try {
      const [h, a, d, c, r, p, depts, m] = await Promise.all([
        getHandovers(), getAssets(), getLocations(), getCategories(),
        getRecipients(), getPositions(), getDepartments(), getModels(),
      ])
      // Build model imageUrl map: modelName → imageUrl
      const modelImageMap: Record<string, string> = {}
      ;(m.data ?? []).forEach((mod: any) => {
        if (mod.code && mod.imageUrl) modelImageMap[mod.code] = mod.imageUrl
      })
      // Inject modelImage into assets that don't have their own imageUrl
      const assetsWithImage = (a.data ?? []).map((asset: any) => ({
        ...asset,
        imageUrl: asset.imageUrl || (asset.model ? modelImageMap[asset.model] : undefined),
      }))
      setHandovers(h.data)
      setAssets(assetsWithImage.filter((x: any) => x.status === 'AVAILABLE'))
      setLocations(d.data.filter((x: any) => x.isActive !== false))
      setCategories(c.data.filter((x: any) => x.isActive !== false))
      setRecipients(r.data.filter((x: any) => x.isActive !== false))
      setPositions(p.data.filter((x: any) => x.isActive !== false))
      setDepartments(depts.data.filter((x: any) => x.isActive !== false))
    } catch (e) {
      console.error('Handover load error:', e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { load() }, [])

  // ─── Asset multi-select toggle ──────────────────────────────────────────────

  const toggleAsset = (id: number) => {
    setForm((p) => {
      const newIds = p.assetIds.includes(id)
        ? p.assetIds.filter((x) => x !== id)
        : [...p.assetIds, id]

      // Auto-populate accessories from selected assets as structured rows
      const accRows: { name: string; serialNumber: string }[] = []
      newIds.forEach(assetId => {
        const asset = assets.find((a: any) => a.id === assetId)
        if (asset?.accessories?.length) {
          asset.accessories.forEach((acc: any) => {
            accRows.push({ name: acc.name ?? '', serialNumber: acc.serialNumber ?? '' })
          })
        }
      })
      return { ...p, assetIds: newIds, accessories: accRows }
    })
  }

  // ─── Photos ─────────────────────────────────────────────────────────────────

  const addPhoto = (file: File | null) => {
    if (!file) return
    const reader = new FileReader()
    reader.onload = (e) => setPhotos((p) => [...p, e.target?.result as string])
    reader.readAsDataURL(file)
  }

  // ─── Open Create ────────────────────────────────────────────────────────────

  const openCreate = () => {
    setEditingId(null)
    setModalKey(k => k + 1)
    const freshForm = {
      assetIds: [] as number[],
      toUser: '', toEmail: '', toPosition: '',
      department: '', location: '',
      assetCondition: DEFAULT_CONDITION,
      accessories: [] as { name: string; serialNumber: string }[],
      note: '',
    }
    setForm(freshForm)
    setAssetSearch('')
    setCategoryFilter(null)
    setFromSig(''); setToSig(''); setPhotos([])
    // Debug: verify form is truly empty before open
    console.log('[openCreate] form reset, assetIds:', freshForm.assetIds)
    open()
  }

  // ─── Open Edit (DRAFT only) ──────────────────────────────────────────────────

  const openEdit = async (h: any) => {
    const full = await getHandover(h.id)
    const data = full.data
    setEditingId(data.id)
    setModalKey(k => k + 1)  // force remount เสมอ ไม่ว่า create หรือ edit
    setForm({
      assetIds:       (data.assets ?? []).map((a: any) => a.id),
      toUser:         data.toUser ?? '',
      toEmail:        data.toEmail ?? '',
      toPosition:     data.toPosition ?? '',
      department:     data.department ?? '',
      location:       data.location ?? '',
      assetCondition: data.assetCondition ?? '',
      accessories:    parseAccessoriesFE(data.accessories).map((a: any) =>
            typeof a === 'string'
              ? { name: a, serialNumber: '' }
              : { name: a.name ?? '', serialNumber: a.serialNumber ?? '' }
          ),
      note:           data.note ?? '',
    })
    setFromSig(data.fromSignature ?? '')
    setToSig(data.toSignature ?? '')
    setPhotos(Array.isArray(data.photos) ? data.photos : [])
    open()
  }

  // ─── Save (create or update) ─────────────────────────────────────────────────

  const handleSave = async () => {
    if (form.assetIds.length === 0) {
      notifications.show({ color: 'red', message: 'Please select at least one asset' }); return
    }
    if (!form.toUser) {
      notifications.show({ color: 'red', message: 'Recipient name is required' }); return
    }
    setSaving(true)
    try {
      const payload = {
        assetIds:       form.assetIds,
        toUser:         form.toUser,
        toEmail:        form.toEmail || undefined,
        toPosition:     form.toPosition || undefined,
        department:     form.department || undefined,
        location:       form.location || undefined,
        assetCondition: form.assetCondition || undefined,
        accessories:    form.accessories?.length
          ? form.accessories.map((a: any) => {
              let line = a.name
              if (a.serialNumber) line += ` (S/N: ${a.serialNumber})`
              return line
            }).join('\n')
          : undefined,
        note:           form.note || undefined,
        fromSignature:  fromSig || undefined,
        toSignature:    toSig || undefined,
        photos:         photos.length ? photos : undefined,
      }
      console.log('[handleSave] payload.assetIds:', payload.assetIds, '| form.assetIds:', form.assetIds)
      if (editingId) {
        await updateHandover(editingId, payload)
        notifications.show({ color: 'lime', message: 'Handover updated successfully' })
      } else {
        await createHandover(payload)
        notifications.show({ color: 'lime', message: 'Handover created successfully' })
      }
      close(); load()
    } catch (e: any) {
      notifications.show({ color: 'red', message: e.response?.data?.message ?? 'An error occurred' })
    } finally { setSaving(false) }
  }

  // ─── Approve ─────────────────────────────────────────────────────────────────

  const openReceive = (h: any) => {
    setSelectedHandover(h)
    setReceiveSig('')
    openSig()
  }

  const handleReceiveSubmit = async () => {
    if (!receiveSig) { notifications.show({ color: 'red', message: 'Please sign first' }); return }
    setApproving(true)
    try {
      await receiveHandover(selectedHandover.id, receiveSig)
      notifications.show({ color: 'teal', message: 'Asset received — handover complete' })
      closeSig(); load()
    } catch (e: any) {
      notifications.show({ color: 'red', message: e.response?.data?.message ?? 'Error' })
    } finally { setApproving(false) }
  }

  // ─── Cancel ──────────────────────────────────────────────────────────────────

  // ── Edit Accessories (RECEIVED only) ─────────────────────────────────────────
  const openEditAccessories = (h: any) => {
    setAccTarget(h)
    setAccForm({
      accessories: parseAccessoriesFE(h.accessories),
      note: h.note ?? '',
    })
    setReplacements([])
    openAccModal()
  }

  const handleSaveAccessories = async () => {
    if (!accTarget) return
    setAccSaving(true)
    try {
      await updateHandoverAccessories(accTarget.id, {
        accessories: accForm.accessories,
        note: accForm.note || undefined,
        replacements: replacements.length > 0 ? replacements.map(({ oldAssetId, reason }) => ({ oldAssetId, reason: reason || undefined })) : undefined,
      })
      notifications.show({ color: 'teal', message: `Handover #${accTarget.id} accessories updated` })
      closeAccModal(); load()
    } catch (e: any) {
      notifications.show({ color: 'red', message: e.response?.data?.message ?? 'Error' })
    } finally { setAccSaving(false) }
  }

  const handleCancel = (h: any) => {
    modals.openConfirmModal({
      title: t('handover.cancelHandoverTitle', 'Cancel Handover'),
      children: <Text size="sm">{t('handover.cancelHandoverBody', 'Cancel handover #{{id}}? This cannot be undone.', { id: h.id })}</Text>,
      labels: { confirm: t('handover.cancelHandoverTitle', 'Cancel Handover'), cancel: t('handover.back', 'Back') },
      confirmProps: { color: 'red' },
      onConfirm: async () => {
        await cancelHandover(h.id)
        notifications.show({ color: 'lime', message: 'Handover cancelled' })
        load()
      },
    })
  }

  const handleApproveHandover = (h: any) => {
    modals.openConfirmModal({
      title: t('handover.approveHandoverTitle', 'Approve Handover'),
      children: <Text size="sm">{t('handover.approveHandoverBody', 'Approve handover #{{id}} to {{toUser}}? {{note}}', { id: h.id, toUser: h.toUser, note: h.toSignature ? t('handover.approveSignedNote', '(Already signed in person — will be marked Received immediately.)') : t('handover.approveEmailNote', '(A confirmation link will be emailed to the recipient.)') })}</Text>,
      labels: { confirm: t('handover.approveHandoverTitle', 'Approve Handover'), cancel: t('handover.back', 'Back') },
      confirmProps: { color: 'teal' },
      onConfirm: async () => {
        try {
          await approveHandover(h.id)
          notifications.show({ color: 'lime', message: t('handover.approvedSuccess', 'Handover approved') })
          load()
        } catch (e: any) {
          notifications.show({ color: 'red', message: e.response?.data?.message ?? t('common.error', 'Something went wrong') })
        }
      },
    })
  }

  const handleRejectHandover = (h: any) => {
    let reason = ''
    modals.openConfirmModal({
      title: t('handover.rejectHandoverTitle', 'Reject Handover'),
      children: (
        <Stack gap="xs">
          <Text size="sm">{t('handover.rejectHandoverBody', 'Reject handover #{{id}} to {{toUser}}?', { id: h.id, toUser: h.toUser })}</Text>
          <Textarea placeholder={t('handover.rejectReasonPlaceholder', 'Reason (optional)')} onChange={(e) => { reason = e.target.value }} minRows={2} />
        </Stack>
      ),
      labels: { confirm: t('handover.rejectHandoverTitle', 'Reject Handover'), cancel: t('handover.back', 'Back') },
      confirmProps: { color: 'red' },
      onConfirm: async () => {
        try {
          await rejectHandover(h.id, reason)
          notifications.show({ color: 'lime', message: t('handover.rejectedSuccess', 'Handover rejected') })
          load()
        } catch (e: any) {
          notifications.show({ color: 'red', message: e.response?.data?.message ?? t('common.error', 'Something went wrong') })
        }
      },
    })
  }

  const handleOpenResend = (h: any) => {
    setResendTarget(h)
    setResendEmail(h.toEmail ?? '')
    openResend()
  }

  const handleOpenDetail = (h: any) => {
    setDetailTarget(h)
    openDetail()
  }

  // ─── Handover History ────────────────────────────────────────────────────────
  const handleOpenHistory = async (h: any) => {
    setHistoryTarget(h)
    setHistoryData([])
    openHistory()
    setLoadingHistory(true)
    try {
      const res = await getHandoverHistory(h.id)
      setHistoryData(res.data)
    } catch (_) {
      notifications.show({ color: 'red', message: t('handover.historyLoadFailed', 'Failed to load history') })
    } finally { setLoadingHistory(false) }
  }

  const handleResendSubmit = async () => {
    if (!resendEmail.trim()) {
      notifications.show({ color: 'red', message: t('handover.resendEmailRequired', 'Please enter an email address') })
      return
    }
    setResending(true)
    try {
      await resendHandoverConfirmEmail(resendTarget.id, resendEmail.trim())
      notifications.show({ color: 'lime', message: t('handover.resendSuccess', 'Confirmation email resent to {{email}}', { email: resendEmail.trim() }) })
      closeResend()
      load()
    } catch (e: any) {
      notifications.show({ color: 'red', message: e.response?.data?.message ?? t('common.error', 'Something went wrong') })
    } finally { setResending(false) }
  }

  // ─── Asset selection grid ─────────────────────────────────────────────────

  // ─── Return ────────────────────────────────────────────────────────────────

  const handleOpenReturn = (h: any) => {
    setReturnTarget(h)
    // Auto-fill accessories from the original handover
    const accText = parseAccessoriesFE(h.accessories)
      .map((a: any) => typeof a === 'string' ? a : `${a.name}${a.serialNumber ? ` (S/N: ${a.serialNumber})` : ''}`).join(', ')
    setReturnForm({
      returnCondition: 'good',
      returnAccessoriesStatus: 'complete',
      returnAccessoriesNote: accText, // pre-fill from handover accessories
      returnPhotos: [],
      returnReceiverName: fullName ?? username ?? '', // auto-fill from login
      returnReceiverPosition: userPosition ?? '',
      returnLocation: '',
      returnNote: '',
      returnSignature: '',
    })
    setReturnSig('')
    const mainItems = (h.assets ?? []).map((a: any) => ({ assetId: a.id, name: a.name, code: a.assetCode, condition: 'good', note: '' }))
    const accessoryItems = parseAccessoriesFE(h.accessories)
      .filter(a => a.assetId)
      .map(a => ({ assetId: a.assetId!, name: a.name, code: a.serialNumber ?? '', condition: 'good', note: '' }))
    setItemResults([...mainItems, ...accessoryItems])
    const nonAssetItems = parseAccessoriesFE(h.accessories)
      .filter(a => !a.assetId)
      .map(a => ({ name: a.name, condition: 'good', note: '' }))
    setNonAssetResults(nonAssetItems)
    openReturn()
  }

  const handleReturn = async () => {
    const receiverName = fullName ?? username ?? returnForm.returnReceiverName
    if (!receiverName) {
      notifications.show({ color: 'red', message: 'Cannot determine receiver — please re-login' }); return
    }
    const missingNote = [...itemResults, ...nonAssetResults].find(r => r.condition === 'repair' && !r.note.trim())
    if (missingNote) {
      notifications.show({ color: 'red', message: t('handover.itemReasonRequired', 'Please describe the issue for {{name}}', { name: missingNote.name }) }); return
    }
    setReturning(true)
    try {
      await api.patch(`/handovers/${returnTarget.id}/return`, {
        ...returnForm,
        returnReceiverName: receiverName,
        returnReceiverPosition: userPosition ?? returnForm.returnReceiverPosition,
        returnPhotos: returnForm.returnPhotos.length > 0 ? JSON.stringify(returnForm.returnPhotos) : undefined,
        returnSignature: returnForm.returnSignature || returnSig || undefined,
        itemResults: itemResults.map(({ assetId, condition, note }) => ({ assetId, condition, note: note || undefined })),
        nonAssetResults: nonAssetResults.map(({ name, condition, note }) => ({ name, condition, note: note || undefined })),
      })
      const lostCount = itemResults.filter(r => r.condition === 'lost').length + nonAssetResults.filter(r => r.condition === 'lost').length
      notifications.show({ color: 'lime', message: lostCount > 0 ? t('handover.returnedWithLost', 'Handover returned — {{count}} item(s) marked as lost, relevant people notified', { count: lostCount }) : t('handover.returnedSuccess', 'Handover returned successfully') })
      closeReturn(); load()
    } catch (e: any) {
      notifications.show({ color: 'red', message: e.response?.data?.message ?? 'Return failed' })
    } finally { setReturning(false) }
  }

  const addReturnPhoto = (file: File | null) => {
    if (!file) return
    const reader = new FileReader()
    reader.onload = (e) => setReturnForm(p => ({ ...p, returnPhotos: [...p.returnPhotos, e.target?.result as string] }))
    reader.readAsDataURL(file)
  }

  // Assets ที่อยู่ใน DRAFT handover อื่นอยู่แล้ว (ไม่นับ handover ที่กำลัง edit)
  const reservedAssetIds = new Set(
    handovers
      .filter(h => h.status === 'DRAFT' && h.id !== editingId)
      .flatMap((h: any) => (h.assets ?? []).map((a: any) => a.id))
  )

  const availableAssets = assets.filter((a) => {
    if (reservedAssetIds.has(a.id) && !form.assetIds.includes(a.id)) return false
    const matchCat = !categoryFilter || a.category === categoryFilter
    const q = assetSearch.toLowerCase().trim()
    const matchSearch = !q ||
      a.name?.toLowerCase().includes(q) ||
      a.serialNumber?.toLowerCase().includes(q) ||
      a.assetCode?.toLowerCase().includes(q)
    return matchCat && matchSearch
  })

  // ─── Render ───────────────────────────────────────────────────────────────

  return (
    <Box p={isSmall ? 16 : 32}>
      <Group justify="space-between" mb="xl">
        <Box>
          <Text style={{ fontFamily: 'Inter, sans-serif', fontSize: 24, fontWeight: 600, letterSpacing: '-0.3px' }}>{t('handover.title','Handover')}</Text>
          <Text size="sm" c="dimmed">{t('handover.subtitle','Asset handover records')}</Text>
          {/* Policy hint: ช่วยให้ user เลือกถูกระหว่าง Handover กับ Transfer */}
          <Alert variant="light" color="blue" radius="md" mt={6} py={6}
            icon={<IconInfoCircle size={15} />}
            styles={{ body: { gap: 4 } }}>
            <Text size="xs" fw={600}>{t('handover.policyHint')}</Text>
            <Text size="xs" c="dimmed">{t('handover.policyTransferHint')} <Anchor href="/transfer" size="xs" fw={600}>{t("common.transfer","Transfer")}</Anchor></Text>
          </Alert>
        </Box>
        <Button leftSection={<IconPlus size={16} />} onClick={openCreate}
          style={{ background: 'var(--brand-primary, #0f172a)', color: 'var(--brand-on-primary, #ffffff)', border: '1px solid var(--brand-border, transparent)', fontWeight: 500 }}>
          {t('handover.createHandover','Create Handover')}
        </Button>
      </Group>

      {/* ── Summary cards (clickable filter) ── */}
      {!loading && (() => {
        const cards = [
          { label: t('common.total','Total'),                  count: handovers.length,                                        color: '#64748b', status: 'ALL' },
          { label: t('handover.pendingApproval','Pending Approval'), count: handovers.filter(h => h.status === 'PENDING_APPROVAL').length, color: '#eab308', status: 'PENDING_APPROVAL' },
          { label: t('nav.handoverAwaitingRecipient','Awaiting Recipient'), count: handovers.filter(h => h.status === 'DRAFT').length,    color: '#eab308', status: 'DRAFT' },
          { label: t('handover.received','Received'),         count: handovers.filter(h => h.status === 'RECEIVED').length,  color: '#14b8a6', status: 'RECEIVED' },
          { label: t('handover.returned','Returned'),         count: handovers.filter(h => h.status === 'RETURNED').length,  color: '#6366f1', status: 'RETURNED' },
          { label: t('handover.rejected','Rejected'),          count: handovers.filter(h => h.status === 'REJECTED' || h.status === 'REJECTED_BY_RECIPIENT').length, color: '#ef4444', status: 'REJECTED' },
          { label: t('handover.cancelled','Cancelled'),        count: handovers.filter(h => h.status === 'CANCELLED').length, color: '#ef4444', status: 'CANCELLED' },
        ]
        return (
          <Group gap="xs" mb="lg" wrap="wrap" justify="flex-start">
            {cards.map(c => (
              <Paper key={c.status} withBorder radius="lg" p="sm"
                onClick={() => setStatusFilter(prev => prev === c.status ? 'ALL' : c.status)}
                style={{
                  borderLeft: `4px solid ${c.color}`, cursor: 'pointer',
                  background: statusFilter === c.status ? '#f8fafc' : '#fff',
                  transition: 'all 0.12s',
                  width: isSmall ? 'calc(50% - 4px)' : 150, flexShrink: 0,
                }}>
                <Text size="xs" c="dimmed" fw={600} style={{ textTransform: 'uppercase', letterSpacing: '0.3px', lineHeight: 1.2 }}>{c.label}</Text>
                <Text size="lg" fw={800} style={{ color: c.color, fontFamily: 'Inter, sans-serif' }}>{c.count}</Text>
              </Paper>
            ))}
          </Group>
        )
      })()}

      {/* ── Table ── */}
      <Box style={{ background: '#fff', borderRadius: 16, border: '1px solid #ebebeb', overflow: 'auto' }}>
        {loading ? <Center p="xl"><Loader color="teal" /></Center> : (() => {
          // unique recipients from handovers
          const recipientOptions = Array.from(
            new Map(handovers.filter(h => h.toUser).map(h => [h.toUser, h.toUser])).values()
          ).sort()

          const filtered = handovers.filter(h => {
            const matchStatus    = statusFilter === 'ALL' || h.status === statusFilter
              || (statusFilter === 'REJECTED' && h.status === 'REJECTED_BY_RECIPIENT')
            const matchRecipient = !recipientFilter || h.toUser === recipientFilter
            const matchSearch    = !search || 
              `hnd-${String(h.id).padStart(4, '0')}`.includes(search.toLowerCase()) ||
              h.toUser?.toLowerCase().includes(search.toLowerCase()) ||
              h.fromUser?.toLowerCase().includes(search.toLowerCase()) ||
              (h.assets ?? []).some((a: any) => 
                a.name?.toLowerCase().includes(search.toLowerCase()) ||
                a.assetCode?.toLowerCase().includes(search.toLowerCase())
              )
            return matchStatus && matchRecipient && matchSearch
          })
          return (
          <>
          {/* ── Filter Bar ── */}
          <Box style={{ padding: '12px 16px', borderBottom: '1px solid #f1f5f9', display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
            {isMobile ? (
              <Indicator label={recipientFilter ? 1 : undefined} disabled={!recipientFilter} size={16} color="teal">
                <Button variant="default" size="xs" leftSection={<IconFilter size={14} />} onClick={openFilterSheet}>
                  {t('assets.filterBtn', 'Filter')}
                </Button>
              </Indicator>
            ) : (
              <Select
                size="xs" placeholder={t('handover.filterRecipient')} clearable searchable
                value={recipientFilter} onChange={setRecipientFilter}
                data={recipientOptions.map(r => ({ value: r, label: r }))}
                style={{ width: 220 }}
                leftSection={<IconUser size={13} />}
              />
            )}
            <TextInput
              size="xs" placeholder={t("handover.searchAssetsPlaceholder","Search assets, name...")} value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ width: isMobile ? '100%' : 220 }}
              leftSection={<IconSearch size={13} />}
            />
            {(recipientFilter || search) && (
              <Text size="xs" c="dimmed">
                {filtered.length} record{filtered.length !== 1 ? 's' : ''} found
              </Text>
            )}
          </Box>

          {/* ── มือถือ: แผ่นตัวกรองเลื่อนขึ้นจากล่าง ── */}
          <Drawer opened={filterSheetOpen} onClose={() => setFilterSheetOpen(false)}
            position="bottom" size="45%" radius="lg 0 0 0"
            title={<Text fw={700}>{t('assets.filterBtn', 'Filter')}</Text>}>
            <Stack gap="md" pb={70}>
              <Select
                label={t('handover.filterRecipient')}
                placeholder={t('handover.filterRecipient')}
                clearable searchable
                value={draftRecipient} onChange={setDraftRecipient}
                data={recipientOptions.map(r => ({ value: r, label: r }))}
                leftSection={<IconUser size={13} />}
              />
            </Stack>
            <Box style={{ position: 'fixed', bottom: 0, left: 0, right: 0, background: '#fff', borderTop: '1px solid #e2e8f0', padding: 16 }}>
              <Group grow>
                <Button variant="default" onClick={clearFilterSheet}>{t('assets.clearFilters', 'Clear All')}</Button>
                <Button onClick={applyFilterSheet} style={{ background: 'var(--brand-primary,#0f172a)', color: '#fff' }}>
                  {t('assets.applyFilters', 'Apply Filters')}
                </Button>
              </Group>
            </Box>
          </Drawer>

          {/* ── Recipient Summary Card ── */}
          {recipientFilter && (
            <Box style={{ background: '#f0fdf4', borderBottom: '1px solid #bbf7d0', padding: '12px 16px' }}>
              <Group gap={12} wrap="wrap">
                <Box>
                  <Text size="xs" c="dimmed" fw={500} mb={2}>{t('handover.recipient')}</Text>
                  <Text size="sm" fw={700}>{recipientFilter}</Text>
                </Box>
                <Box>
                  <Text size="xs" c="dimmed" fw={500} mb={2}>{t("handover.totalHandovers","TOTAL HANDOVERS")}</Text>
                  <Text size="sm" fw={700}>{filtered.length}</Text>
                </Box>
                <Box>
                  <Text size="xs" c="dimmed" fw={500} mb={2}>{t("handover.assetsHolding","ASSETS HOLDING")}</Text>
                  <Text size="sm" fw={700}>
                    {filtered.filter(h => h.status === 'RECEIVED').reduce((s: number, h: any) => s + (h.assets?.length ?? 0), 0)} items
                  </Text>
                </Box>
                <Box style={{ flex: 1 }}>
                  <Text size="xs" c="dimmed" fw={500} mb={4}>{t("handover.receivedAssets","RECEIVED ASSETS")}</Text>
                  <Group gap={6} wrap="wrap">
                    {filtered
                      .filter(h => h.status === 'RECEIVED')
                      .flatMap((h: any) => h.assets ?? [])
                      .map((a: any) => (
                        <Badge key={a.id} size="sm" variant="light" color="teal">
                          {a.assetCode} — {a.name}
                        </Badge>
                      ))
                    }
                    {filtered.filter(h => h.status === 'RECEIVED').flatMap((h: any) => h.assets ?? []).length === 0 && (
                      <Text size="xs" c="dimmed">{t("handover.noReceivedHandovers","No received handovers")}</Text>
                    )}
                  </Group>
                </Box>
              </Group>
            </Box>
          )}

          {isMobile ? (
            // ── มือถือ: การ์ด — เดิมตาราง 11 คอลัมน์ (#, Assets, From, To, Dept, Location, Date,
            // Status, Photos, Signatures, Actions) กับปุ่มจัดการสูงสุด 8 ปุ่มต่อแถวพึ่ง Tooltip
            // ล้วนๆ — รวม action เป็นเมนู ⋮ (เหมือน MaintenancePage/AssetQuickView) ส่วนข้อมูล
            // อื่น (แผนก/สถานที่/รูปภาพ/ลายเซ็น) พับไว้ กดที่การ์ดเพื่อขยายดู ──
            filtered.length === 0 ? (
              <Center p="xl"><Text c="dimmed">{t('handover.noRecords','No handover records')}</Text></Center>
            ) : (
              <Stack gap="xs" p="xs">
                {filtered.map((h: any) => {
                  const hActions = [
                    ...(h.status === 'PENDING_APPROVAL' ? [
                      ...(canProcess ? [
                        { key: 'approve', label: t("handover.approveTooltip","Approve"), color: 'teal', icon: (s: number) => <IconCheck size={s} />, onClick: () => handleApproveHandover(h) },
                        { key: 'reject', label: t("handover.rejectTooltip","Reject"), color: 'red', icon: (s: number) => <IconX size={s} />, onClick: () => handleRejectHandover(h) },
                      ] : []),
                      { key: 'cancel1', label: t("common.cancel","Cancel"), color: 'gray', icon: (s: number) => <IconBan size={s} />, onClick: () => handleCancel(h) },
                    ] : []),
                    ...(h.status === 'DRAFT' ? [
                      { key: 'edit', label: t("common.edit","Edit"), color: 'blue', icon: (s: number) => <IconEdit size={s} />, onClick: () => openEdit(h) },
                      ...(canProcess ? [
                        { key: 'confirm', label: t("handover.confirmReceipt","Confirm Receipt"), color: 'teal', icon: (s: number) => <IconCheck size={s} />, onClick: () => openReceive(h) },
                        { key: 'resend', label: t("handover.resendEmail","Resend Confirmation Email"), color: 'indigo', icon: (s: number) => <IconMailForward size={s} />, onClick: () => handleOpenResend(h) },
                      ] : []),
                      { key: 'cancel2', label: t("common.cancel","Cancel"), color: 'red', icon: (s: number) => <IconBan size={s} />, onClick: () => handleCancel(h) },
                    ] : []),
                    ...(h.status === 'RECEIVED' ? [
                      ...(canProcess ? [
                        { key: 'editAcc', label: t("handover.editAccessories","Edit Accessories"), color: 'teal', icon: (s: number) => <IconEdit size={s} />, onClick: () => openEditAccessories(h) },
                      ] : []),
                      { key: 'return', label: t('handover.returnTooltip','Return'), color: 'blue', icon: (s: number) => <IconArrowBack size={s} />, onClick: () => handleOpenReturn(h) },
                    ] : []),
                    { key: 'detail', label: t("handover.viewDetails","View Details"), color: 'grape', icon: (s: number) => <IconInfoCircle size={s} />, onClick: () => handleOpenDetail(h) },
                    { key: 'history', label: t("handover.viewHistory","History"), color: 'indigo', icon: (s: number) => <IconHistory size={s} />, onClick: () => handleOpenHistory(h) },
                    { key: 'print', label: t("common.print","Print"), color: 'gray', icon: (s: number) => <IconPrinter size={s} />, onClick: async () => {
                        try {
                          const res = await downloadHandoverPdf(h.id, i18n.language === 'th' ? 'th' : 'en')
                          const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
                          window.open(url, '_blank')
                          setTimeout(() => URL.revokeObjectURL(url), 30_000)
                        } catch { notifications.show({ color: 'red', message: t('handover.pdfGenerationFailed', 'Failed to generate PDF') }) }
                      } },
                  ]
                  return (
                    <Card key={h.id} withBorder radius="lg" p="md">
                      <Group justify="space-between" align="flex-start" wrap="nowrap" gap="xs">
                        <Box style={{ minWidth: 0, flex: 1 }}>
                          <Text size="sm" fw={600} style={{ color: '#0f172a' }}>HND-{String(h.id).padStart(4, '0')}</Text>
                          <Text size="xs" c="dimmed">{h.fromUser} → {h.toUser}</Text>
                        </Box>
                        <Group gap={4} wrap="nowrap" style={{ flexShrink: 0 }}>
                          <Badge color={STATUS_COLOR[h.status] ?? 'gray'} variant="light" size="sm">{h.status}</Badge>
                          <Menu shadow="md" width={220} position="bottom-end">
                            <Menu.Target>
                              <ActionIcon variant="subtle" color="gray" size="lg"><IconDotsVertical size={18} /></ActionIcon>
                            </Menu.Target>
                            <Menu.Dropdown>
                              {hActions.map(a => (
                                <Menu.Item key={a.key} leftSection={a.icon(15)} color={a.color} onClick={a.onClick}>
                                  {a.label}
                                </Menu.Item>
                              ))}
                            </Menu.Dropdown>
                          </Menu>
                        </Group>
                      </Group>

                      <Divider my={8} />

                      <Group justify="space-between" align="flex-start" wrap="wrap" gap="xs" mb={8}>
                        <Text size="xs" c="dimmed">{departments.find(d => d.code === h.department)?.name ?? h.department ?? '-'}{h.location ? ` · ${h.location}` : ''}</Text>
                        <Text size="xs" c="dimmed">{new Date(h.handoverDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</Text>
                      </Group>

                      <Stack gap={4}>
                        {(h.assets ?? []).slice(0, 3).map((a: any) => (
                          <Group key={a.id} gap={6}>
                            {a.imageUrl && <Image src={a.imageUrl} w={22} h={22} radius="sm" fit="cover" style={{ border: '1px solid #ebebeb' }} />}
                            <Text size="xs" c="dimmed" style={{ cursor: 'pointer', color: '#0d9488', textDecoration: 'underline dotted' }}
                              onClick={() => openQv(a.assetCode)}>
                              {a.assetCode} — {a.name}
                            </Text>
                          </Group>
                        ))}
                        {(h.assets ?? []).length > 3 && <Text size="xs" c="dimmed">+{h.assets.length - 3} {t('common.more', 'more')}</Text>}
                      </Stack>

                      <Group gap={6} mt={8}>
                        <Badge size="xs" color={h.fromSignature ? 'lime' : 'gray'} variant="light">{t('handover.sender')}</Badge>
                        <Badge size="xs" color={h.toSignature ? 'lime' : 'gray'} variant="light">{t('handover.receiver')}</Badge>
                        {(h.photos ?? []).length > 0 && (
                          <Badge size="xs" color="blue" variant="light" leftSection={<IconPhoto size={10} />}
                            onClick={() => openLightbox(h.photos ?? [], 0)} style={{ cursor: 'pointer' }}>
                            {h.photos.length}
                          </Badge>
                        )}
                      </Group>
                    </Card>
                  )
                })}
              </Stack>
            )
          ) : (
          <Table highlightOnHover>
            <Table.Thead style={{ background: '#f8f7f4' }}>
              <Table.Tr>
                <Table.Th>#</Table.Th>
                <Table.Th>{t('handover.colAssets','Assets')}</Table.Th>
                <Table.Th>{t('handover.colFrom','From')}</Table.Th>
                <Table.Th>{t('handover.colTo','To')}</Table.Th>
                <Table.Th>{t('handover.colDept',"Recipient's Dept.")}</Table.Th>
                <Table.Th>{t('handover.colLocation','Location')}</Table.Th>
                <Table.Th>{t('handover.colDate','Date')}</Table.Th>
                <Table.Th>{t('handover.colStatus','Status')}</Table.Th>
                <Table.Th>{t('handover.colPhotos')}</Table.Th>
                <Table.Th>{t('handover.colSig','Signatures')}</Table.Th>
                <Table.Th></Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {filtered.length === 0 ? (
                <Table.Tr><Table.Td colSpan={9}><Center p="xl"><Text c="dimmed">{t('handover.noRecords','No handover records')}</Text></Center></Table.Td></Table.Tr>
              ) : filtered.map((h) => (
                <Table.Tr key={h.id}>
                  <Table.Td><Text size="sm" fw={700}>HND-{String(h.id).padStart(4, '0')}</Text></Table.Td>
                  <Table.Td>
                    {(h.assets ?? []).slice(0, 2).map((a: any) => (
                      <Group key={a.id} gap={6} mb={2}>
                        {a.imageUrl && <Image src={a.imageUrl} w={28} h={28} radius="sm" fit="cover" style={{ border: '1px solid #ebebeb' }} />}
                        <Box>
                          <Text size="xs" fw={600}>{a.name}</Text>
                          <Text size="xs" c="dimmed" style={{ cursor: 'pointer', color: '#0d9488', textDecoration: 'underline dotted' }}
                            onClick={() => openQv(a.assetCode)}>
                            {a.assetCode}
                          </Text>
                        </Box>
                      </Group>
                    ))}
                    {(h.assets ?? []).length > 2 && <Text size="xs" c="dimmed">+{h.assets.length - 2} more</Text>}
                  </Table.Td>
                  <Table.Td><Text size="sm">{h.fromUser}</Text></Table.Td>
                  <Table.Td><Text size="sm">{h.toUser}</Text></Table.Td>
                  <Table.Td><Text size="sm">{departments.find(d => d.code === h.department)?.name ?? h.department ?? '-'}</Text></Table.Td>
                  <Table.Td><Text size="sm" c="dimmed">{h.location ?? '-'}</Text></Table.Td>
                  <Table.Td>
                    <Text size="xs" c="dimmed">
                      {new Date(h.handoverDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
                    </Text>
                  </Table.Td>
                  <Table.Td>
                    <Badge color={STATUS_COLOR[h.status] ?? 'gray'} variant="light" size="sm">{h.status}</Badge>
                  </Table.Td>
                  {/* Condition Photos */}
                  <Table.Td>
                    {(h.photos ?? []).length > 0 ? (
                      <Group gap={4}>
                        {(h.photos ?? []).slice(0, 3).map((url: string, i: number) => (
                          <Image key={i} src={url} w={32} h={32} radius="sm" fit="cover"
                            style={{ border: '1px solid #e2e8f0', cursor: 'pointer' }}
                            onClick={() => openLightbox(h.photos ?? [], i)} />
                        ))}
                        {(h.photos ?? []).length > 3 && (
                          <Text size="xs" c="dimmed" style={{ cursor: 'pointer' }}
                            onClick={() => openLightbox(h.photos ?? [], 3)}>
                            +{(h.photos ?? []).length - 3}
                          </Text>
                        )}
                      </Group>
                    ) : (
                      <Text size="xs" c="dimmed">—</Text>
                    )}
                  </Table.Td>
                  <Table.Td>
                    <Group gap={4}>
                      <Badge size="xs" color={h.fromSignature ? 'lime' : 'gray'} variant="light">{t('handover.sender')}</Badge>
                      <Badge size="xs" color={h.toSignature ? 'lime' : 'gray'} variant="light">{t('handover.receiver')}</Badge>
                    </Group>
                  </Table.Td>
                  <Table.Td>
                    <Group gap={4}>
                      {h.status === 'PENDING_APPROVAL' && (
                        <>
                          {canProcess && (
                            <>
                              <Tooltip label={t("handover.approveTooltip","Approve")}><ActionIcon variant="subtle" color="teal" onClick={() => handleApproveHandover(h)}><IconCheck size={16} /></ActionIcon></Tooltip>
                              <Tooltip label={t("handover.rejectTooltip","Reject")}><ActionIcon variant="subtle" color="red" onClick={() => handleRejectHandover(h)}><IconX size={16} /></ActionIcon></Tooltip>
                            </>
                          )}
                          <Tooltip label={t("common.cancel","Cancel")}><ActionIcon variant="subtle" color="gray" onClick={() => handleCancel(h)}><IconBan size={16} /></ActionIcon></Tooltip>
                        </>
                      )}
                      {h.status === 'DRAFT' && (
                        <>
                          <Tooltip label={t("common.edit","Edit")}><ActionIcon variant="subtle" color="blue" onClick={() => openEdit(h)}><IconEdit size={16} /></ActionIcon></Tooltip>
                          {canProcess && h.status === 'DRAFT' && <Tooltip label={t("handover.confirmReceipt","Confirm Receipt")}><ActionIcon variant="subtle" color="teal" onClick={() => openReceive(h)}><IconCheck size={16} /></ActionIcon></Tooltip>}
                          {canProcess && h.status === 'DRAFT' && <Tooltip label={t("handover.resendEmail","Resend Confirmation Email")}><ActionIcon variant="subtle" color="indigo" onClick={() => handleOpenResend(h)}><IconMailForward size={16} /></ActionIcon></Tooltip>}
                          <Tooltip label={t("common.cancel","Cancel")}><ActionIcon variant="subtle" color="red" onClick={() => handleCancel(h)}><IconBan size={16} /></ActionIcon></Tooltip>
                        </>
                      )}
                      {h.status === 'RECEIVED' && (
                        <>
                          {canProcess && (
                            <Tooltip label={t("handover.editAccessories","Edit Accessories")}>
                              <ActionIcon variant="subtle" color="teal" onClick={() => openEditAccessories(h)}>
                                <IconEdit size={16} />
                              </ActionIcon>
                            </Tooltip>
                          )}
                          <Tooltip label={t('handover.returnTooltip')}>
                            <ActionIcon variant="subtle" color="blue" onClick={() => handleOpenReturn(h)}><IconArrowBack size={16} /></ActionIcon>
                          </Tooltip>
                        </>
                      )}
                      <Tooltip label={t("handover.viewDetails","View Details")}><ActionIcon variant="subtle" color="grape" onClick={() => handleOpenDetail(h)}><IconInfoCircle size={16} /></ActionIcon></Tooltip>
                      <Tooltip label={t("handover.viewHistory","History")}><ActionIcon variant="subtle" color="indigo" onClick={() => handleOpenHistory(h)}><IconHistory size={16} /></ActionIcon></Tooltip>
                      <Tooltip label={t("common.print","Print")}><ActionIcon variant="subtle" color="gray" onClick={async () => {
                        try {
                          const res = await downloadHandoverPdf(h.id, i18n.language === 'th' ? 'th' : 'en')
                          const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
                          window.open(url, '_blank')
                          setTimeout(() => URL.revokeObjectURL(url), 30_000)
                        } catch { notifications.show({ color: 'red', message: t('handover.pdfGenerationFailed', 'Failed to generate PDF') }) }
                      }}><IconPrinter size={16} /></ActionIcon></Tooltip>
                    </Group>
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
          )}
          </>
          )
        })()}
      </Box>

      {/* ── Create / Edit Modal ── */}
      <Modal opened={opened} onClose={close} size="xl" radius="lg"
        key={modalKey}
        scrollAreaComponent={ScrollArea.Autosize}
        title={<Text fw={600} style={{ fontFamily: 'Inter, sans-serif', fontSize: 18 }}>{editingId ? `${t('handover.editHandover','Edit Handover')} #${editingId}` : t('handover.createHandover','Create Handover')}</Text>}
      >
        <Stack gap="md">
          {/* Parties */}
          {/* Recipient selector — auto-fills other fields */}
          <Select
            label={t("handover.recipient","Recipient *")}
            placeholder={t("handover.searchRecipientPlaceholder","Search and select recipient...")}
            description={t("handover.selectFromDirectory","Select from directory to auto-fill details below")}
            data={recipients.map((r) => ({
              value: String(r.id),
              label: r.name + (r.position ? ` — ${r.position}` : '') + (r.department ? ` · ${r.department}` : ''),
            }))}
            value={null}
            onChange={(v) => {
              if (!v) return
              const rec = recipients.find(r => String(r.id) === v)
              if (rec) {
                // rec.department เป็น free-text ไม่ผูกกับ departments.code โดยตรง
                // จับคู่แบบ case-insensitive กับทั้ง code และ name เพื่อหาค่า code ที่ถูกต้องสำหรับ Select
                const matched = rec.department
                  ? departments.find(d =>
                      d.code?.toLowerCase() === rec.department.toLowerCase() ||
                      d.name?.toLowerCase() === rec.department.toLowerCase()
                    )
                  : undefined
                setForm((p) => ({
                  ...p,
                  toUser:     rec.name,
                  toEmail:    rec.email ?? '',
                  toPosition: rec.position ?? '',
                  department: matched?.code ?? p.department,
                }))
              }
            }}
          />

          <SimpleGrid cols={2} mt={4}>
            <TextInput
              label={t("handover.fullName","Full Name *")}
              placeholder={t("handover.fullNamePlaceholder","Full name")}
              value={form.toUser}
              onChange={(e) => setForm((p) => ({ ...p, toUser: e.target.value }))}
            />
            <TextInput
              label={t("handover.recipientEmail","Recipient Email")}
              placeholder="email@company.com"
              value={form.toEmail}
              onChange={(e) => setForm((p) => ({ ...p, toEmail: e.target.value }))}
            />
            <Select
              label={t("handover.positionTitle","Position / Title")}
              placeholder={t("handover.selectPositionPlaceholder","Select position")}
              data={positions.map((p) => ({ value: p.name, label: p.name }))}
              value={form.toPosition || null}
              onChange={(v) => setForm((p) => ({ ...p, toPosition: v ?? '' }))}
              searchable
              clearable
            />
            <Select
              label={t("handover.recipientDept","Recipient's Department (for document only)")}
              placeholder={t('handover.selectDept')}
              data={departments.map((d) => ({ value: d.code, label: d.name }))}
              value={form.department || null}
              onChange={(v) => setForm((p) => ({ ...p, department: v ?? '' }))}
              searchable
              clearable
            />
            <Select
              label={t("handover.locationRoom","Location / Room")}
              placeholder={t('handover.selectLocation')}
              data={locations.map((l) => ({ value: l.name, label: localizedName(l, i18n.language) }))}
              value={form.location || null}
              onChange={(v) => setForm((p) => ({ ...p, location: v ?? '' }))}
              searchable
              clearable
            />
          </SimpleGrid>

          <Divider label={t("handover.selectAssets","Select Assets")} labelPosition="left" />

          {/* ── Selected assets — แสดงตลอดด้านบน ── */}
          {form.assetIds.length > 0 && (
            <Box style={{ background: '#f0fdf4', border: '1.5px solid #0d9488', borderRadius: 10, padding: '10px 12px' }}>
              <Group justify="space-between" mb={6}>
                <Text size="xs" fw={700} c="teal">{form.assetIds.length} asset(s) selected</Text>
                <Text size="xs" c="dimmed" style={{ cursor: 'pointer', textDecoration: 'underline' }}
                  onClick={() => setForm(p => ({ ...p, assetIds: [], accessories: [] }))}>
                  {t('handover.clearAll')}
                </Text>
              </Group>
              <Group gap={6} wrap="wrap">
                {form.assetIds.map(id => {
                  const a = assets.find(x => x.id === id)
                  if (!a) return null
                  return (
                    <Badge key={id} size="sm" color="teal" variant="light"
                      rightSection={
                        <Box style={{ cursor: 'pointer', marginLeft: 4, lineHeight: 1 }}
                          onClick={(e) => { e.stopPropagation(); toggleAsset(id) }}>✕</Box>
                      }>
                      {a.assetCode}
                    </Badge>
                  )
                })}
              </Group>
            </Box>
          )}

          {/* ── Search + Category filter ── */}
          <Group gap={8}>
            <TextInput
              placeholder={t("handover.searchAssetPlaceholder","Search by name, serial no., code...")}
              size="xs"
              leftSection={<IconSearch size={13} />}
              value={assetSearch}
              onChange={e => setAssetSearch(e.target.value)}
              style={{ flex: 1 }}
              radius="md"
            />
            <Select
              placeholder={t("handover.allCategories","All categories")}
              size="xs"
              clearable
              data={categories.map((c) => ({ value: c.code, label: localizedName(c, i18n.language) }))}
              value={categoryFilter}
              onChange={setCategoryFilter}
              style={{ width: 170 }}
            />
          </Group>

          {/* ── Asset grid (unselected + matching search) ── */}
          <Box>
            <Box style={{ maxHeight: 280, overflowY: 'auto', border: '1px solid #ebebeb', borderRadius: 10, padding: 8 }}>
              {availableAssets.length === 0 ? (
                <Center p="md">
                  <Text size="sm" c="dimmed">
                    {assetSearch ? `No assets matching "${assetSearch}"` : 'No available assets'}
                  </Text>
                </Center>
              ) : (
                <SimpleGrid cols={2} spacing="xs">
                  {availableAssets.map((a) => {
                    const selected = form.assetIds.includes(a.id)
                    return (
                      <Box key={a.id} onClick={() => toggleAsset(a.id)}
                        style={{
                          display: 'flex', gap: 10, alignItems: 'center', padding: '8px 10px',
                          borderRadius: 8, cursor: 'pointer',
                          border: selected ? '2px solid #0d9488' : '2px solid transparent',
                          background: selected ? '#f0fdf4' : '#fafafa',
                          transition: 'all .15s',
                        }}>
                        {a.imageUrl ? (
                          <Image src={a.imageUrl} w={36} h={36} radius="sm" fit="cover" style={{ flexShrink: 0 }} />
                        ) : (
                          <Box w={36} h={36} style={{ background: '#eee', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                            <IconPhoto size={16} color="#bbb" />
                          </Box>
                        )}
                        <Box style={{ minWidth: 0, flex: 1 }}>
                          <Text size="xs" fw={700} style={{ fontFamily: 'Inter, sans-serif' }} lineClamp={1}>{a.assetCode}</Text>
                          <Text size="xs" lineClamp={1}>{a.name}</Text>
                          <Text size="xs" c="dimmed" lineClamp={1}>{a.serialNumber}</Text>
                        </Box>
                        {selected && <IconCheck size={15} color="#0d9488" style={{ flexShrink: 0 }} />}
                      </Box>
                    )
                  })}
                </SimpleGrid>
              )}
            </Box>
          </Box>

          <Divider label={t("handover.handoverDetails","Handover Details")} labelPosition="left" />

          {/* ── Asset Condition — เลือกภาษา + แก้ไขได้ ── */}
          <Box>
            <Text size="sm" fw={500} mb={4}>{t('handover.assetCondition')}</Text>
            <Text size="xs" c="dimmed" mb={6}>{t('handover.conditionLangHint')}</Text>
            <Group gap={6} mb={8}>
              <Button size="xs" variant="light" color="teal"
                leftSection={<span>🇹🇭</span>}
                onClick={() => setForm(p => ({ ...p, assetCondition: t('handover.conditionTh') }))}>
                {t('handover.conditionLangTh')}
              </Button>
              <Button size="xs" variant="light" color="blue"
                leftSection={<span>🇬🇧</span>}
                onClick={() => setForm(p => ({ ...p, assetCondition: t('handover.conditionEn') }))}>
                {t('handover.conditionLangEn')}
              </Button>
              {form.assetCondition && (
                <Tooltip label="ล้างข้อความ">
                  <ActionIcon size="sm" variant="subtle" color="gray"
                    onClick={() => setForm(p => ({ ...p, assetCondition: '' }))}>
                    <IconArrowBack size={14} />
                  </ActionIcon>
                </Tooltip>
              )}
            </Group>
            <Textarea
              minRows={3}
              autosize
              placeholder={t('handover.assetConditionDesc')}
              value={form.assetCondition}
              onChange={(e) => setForm(p => ({ ...p, assetCondition: e.target.value }))}
            />
          </Box>
          {/* ── Accessories Included ── */}
          <Box>
            <Group justify="space-between" mb={6}>
              <Box>
                <Text size="sm" fw={500}>{t('handover.accessories')}</Text>
                <Text size="xs" c="dimmed">{t('handover.accessoriesNonAssetDesc', 'For items not tracked in the Asset system, e.g. a bag or charger — assets to be included go in the asset list above.')}</Text>
              </Box>
            </Group>

            {/* ── Combined list — แก้ไขได้ทุกรายการ ── */}
            <Stack gap={6}>
              {(form.accessories ?? []).map((acc: any, i: number) => (
                <Group key={i} gap="sm" align="center"
                  style={{
                    background: acc.assetId ? '#f0fdf4' : '#f8fafc',
                    borderRadius: 8, padding: '8px 12px',
                    border: `1px solid ${acc.assetId ? '#0d9488' : '#e2e8f0'}`,
                  }}>
                  {acc.assetId && (
                    <Tooltip label={t("handover.fromAssetList","From Asset List")}>
                      <Text size="xs" c="teal" fw={700} style={{ flexShrink: 0 }}>📦</Text>
                    </Tooltip>
                  )}
                  <TextInput
                    size="xs" placeholder={t("handover.itemNameExample","Item name e.g. Bag, Mouse, Charger")}
                    style={{ flex: 2 }}
                    value={acc.name}
                    onChange={e => setForm((p) => {
                      const list = [...(p.accessories as any[])]
                      list[i] = { ...list[i], name: e.target.value }
                      return { ...p, accessories: list }
                    })}
                  />
                  <TextInput
                    size="xs" placeholder={t("handover.serialOptionalPlaceholder","Serial No. (optional)")}
                    style={{ flex: 1.5 }}
                    value={acc.serialNumber ?? ''}
                    onChange={e => setForm((p) => {
                      const list = [...(p.accessories as any[])]
                      list[i] = { ...list[i], serialNumber: e.target.value }
                      return { ...p, accessories: list }
                    })}
                  />
                  <ActionIcon variant="subtle" color="red" size="sm"
                    onClick={() => setForm((p) => ({
                      ...p,
                      accessories: (p.accessories as any[]).filter((_: any, j: number) => j !== i),
                    }))}>
                    <IconX size={13} />
                  </ActionIcon>
                </Group>
              ))}
              {/* ปุ่มเพิ่ม manual */}
              <Button size="xs" variant="light" color="gray" leftSection={<IconPlus size={12} />}
                style={{ alignSelf: 'flex-start' }}
                onClick={() => setForm((p) => ({
                  ...p,
                  accessories: [...(p.accessories as any[]), { name: '', serialNumber: '' }],
                }))}>
                + พิมพ์เพิ่มเอง
              </Button>
            </Stack>
          </Box>
          <Textarea label={t('handover.remarks')} minRows={2}
            value={form.note} onChange={(e) => setForm((p) => ({ ...p, note: e.target.value }))} />

          {/* Photos */}
          <Box>
            <Text size="sm" fw={600} mb={6}>{t('handover.conditionPhotos')}</Text>
            <Group gap="sm" wrap="wrap">
              {photos.map((p, i) => (
                <Box key={i} style={{ position: 'relative' }}>
                  <Image src={p} w={88} h={68} radius="md" fit="cover" style={{ border: '1px solid #ebebeb' }} />
                  <ActionIcon size="xs" color="red" variant="filled" radius="xl"
                    style={{ position: 'absolute', top: -6, right: -6 }}
                    onClick={() => setPhotos((prev) => prev.filter((_, j) => j !== i))}>
                    <IconX size={10} />
                  </ActionIcon>
                </Box>
              ))}
              <FileButton onChange={addPhoto} accept="image/*">
                {(props) => (
                  <Box {...props} w={88} h={68}
                    style={{ background: '#f8f7f4', borderRadius: 8, border: '1.5px dashed #ddd', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
                    <IconPhoto size={20} color="#bbb" />
                    <Text size="xs" c="dimmed">{t('handover.add')}</Text>
                  </Box>
                )}
              </FileButton>
            </Group>
          </Box>

          {/* Signatures — Sender only at create time */}
          <Divider label={t('handover.senderSignature')} labelPosition="left" />
          <Box style={{ maxWidth: 320 }}>
            <SignaturePad label={t('handover.senderSignatureRequired')} onSave={setFromSig} value={fromSig} />
            <Text size="xs" c="dimmed" mt={4}>
              {t('handover.receiverWillSign')}
            </Text>
          </Box>

          <Group justify="flex-end" mt="sm">
            <Button variant="default" onClick={close}>{t("common.cancel","Cancel")}</Button>
            <Button loading={saving} onClick={handleSave}
              style={{ background: 'var(--brand-primary, #0f172a)', color: 'var(--brand-on-primary, #ffffff)', border: '1px solid var(--brand-border, transparent)', fontWeight: 500 }}>
              {editingId ? t('handover.saveChanges','Save Changes') : t('handover.createHandover','Create Handover')}
            </Button>
          </Group>
        </Stack>
      </Modal>

      {/* ── View Details Modal ── */}
      <Modal opened={detailOpened} onClose={closeDetail} size="md" radius="lg"
        title={<Text fw={600}>{t('handover.viewDetails', 'View Details')} — #{detailTarget?.id}</Text>}>
        {detailTarget && (
          <Stack gap="md">
            <Group justify="space-between">
              <Badge size="lg" color={detailTarget.status === 'RETURNED' ? 'gray' : detailTarget.status === 'RECEIVED' ? 'teal' : 'orange'}>
                {detailTarget.status}
              </Badge>
              <Text size="xs" c="dimmed">{new Date(detailTarget.createdAt).toLocaleDateString('th-TH')}</Text>
            </Group>

            <Box>
              <Text size="xs" fw={700} c="dimmed" mb={4}>{t('handover.assets', 'Assets')}</Text>
              <Stack gap={4}>
                {(detailTarget.assets ?? []).map((a: any, i: number) => (
                  <Box key={i} style={{ background: '#f8f7f4', borderRadius: 8, padding: '6px 10px' }}>
                    <Text size="sm" fw={600}>{a.name}</Text>
                    <Text size="xs" c="dimmed">
                      {a.assetCode}{a.serialNumber ? ` · S/N ${a.serialNumber}` : ''}
                      {[a.brand, a.model].filter(Boolean).join(' ') ? ` · ${[a.brand, a.model].filter(Boolean).join(' ')}` : ''}
                    </Text>
                  </Box>
                ))}
              </Stack>
            </Box>

            {parseAccessoriesFE(detailTarget.accessories).length > 0 && (
              <Box>
                <Text size="xs" fw={700} c="dimmed" mb={4}>{t('handover.accessories', 'Accessories')}</Text>
                <Stack gap={4}>
                  {parseAccessoriesFE(detailTarget.accessories).map((a, i) => (
                    <Group key={i} justify="space-between" style={{ background: '#f8f7f4', borderRadius: 8, padding: '6px 10px' }}>
                      <Box>
                        <Text size="sm">{a.name}</Text>
                        {a.serialNumber && <Text size="xs" c="dimmed">S/N {a.serialNumber}</Text>}
                      </Box>
                      {a.assetId && <Badge size="xs" color="blue" variant="light">{t('handover.linkedAsset', 'Linked Asset')}</Badge>}
                    </Group>
                  ))}
                </Stack>
              </Box>
            )}

            <Box>
              <Text size="xs" fw={700} c="dimmed" mb={4}>{t('handover.handoverInfo', 'Handover Info')}</Text>
              <SimpleGrid cols={2} spacing={4}>
                <Box><Text size="xs" c="dimmed">{t('handover.from','From')}</Text><Text size="sm">{detailTarget.fromUser}</Text></Box>
                <Box><Text size="xs" c="dimmed">{t('handover.to','To')}</Text><Text size="sm">{detailTarget.toUser}</Text></Box>
                <Box><Text size="xs" c="dimmed">{t('handover.handoverDate','Handover Date')}</Text><Text size="sm">{detailTarget.handoverDate ? new Date(detailTarget.handoverDate).toLocaleDateString('th-TH') : (detailTarget.createdAt ? new Date(detailTarget.createdAt).toLocaleDateString('th-TH') : '—')}</Text></Box>
                {detailTarget.department && <Box><Text size="xs" c="dimmed">{t('common.department','Department')}</Text><Text size="sm">{detailTarget.department}</Text></Box>}
                {detailTarget.location && <Box><Text size="xs" c="dimmed">{t('common.location','Location')}</Text><Text size="sm">{detailTarget.location}</Text></Box>}
              </SimpleGrid>
              {detailTarget.assetCondition && (
                <Box mt={6}><Text size="xs" c="dimmed">{t('handover.condition','Condition')}</Text><Text size="sm">{detailTarget.assetCondition}</Text></Box>
              )}
              {detailTarget.note && (
                <Box mt={6}><Text size="xs" c="dimmed">{t('common.note','Note')}</Text><Text size="sm">{detailTarget.note}</Text></Box>
              )}
            </Box>

            {detailTarget.status === 'RETURNED' && (
              <Box>
                <Divider label={t('handover.returnInfo', 'Return Info')} labelPosition="left" mb="xs" />
                <SimpleGrid cols={2} spacing={4}>
                  <Box><Text size="xs" c="dimmed">{t('handover.returnDate','Return Date')}</Text><Text size="sm">{detailTarget.returnDate ? new Date(detailTarget.returnDate).toLocaleDateString('th-TH') : '—'}</Text></Box>
                  <Box><Text size="xs" c="dimmed">{t('handover.condition','Condition')}</Text><Text size="sm">{detailTarget.returnCondition ?? '—'}</Text></Box>
                  <Box><Text size="xs" c="dimmed">{t('handover.accessoriesStatus','Accessories Status')}</Text><Text size="sm">{detailTarget.returnAccessoriesStatus ?? '—'}</Text></Box>
                  <Box><Text size="xs" c="dimmed">{t('handover.receivedBy','Received By')}</Text><Text size="sm">{detailTarget.returnReceiverName ?? '—'}</Text></Box>
                </SimpleGrid>
                {detailTarget.returnAccessoriesNote && (
                  <Box mt={6}><Text size="xs" c="dimmed">{t('handover.accessoriesNote','Accessories Note')}</Text><Text size="sm">{detailTarget.returnAccessoriesNote}</Text></Box>
                )}
                {detailTarget.returnNote && (
                  <Box mt={6}><Text size="xs" c="dimmed">{t('common.note','Note')}</Text><Text size="sm">{detailTarget.returnNote}</Text></Box>
                )}
                {parsePhotos(detailTarget.returnPhotos).length > 0 && (
                  <SimpleGrid cols={4} mt="xs">
                    {parsePhotos(detailTarget.returnPhotos).map((p: string, i: number) => (
                      <Image key={i} src={p} radius="sm" style={{ aspectRatio: '1', objectFit: 'cover' }} />
                    ))}
                  </SimpleGrid>
                )}
              </Box>
            )}
          </Stack>
        )}
      </Modal>

      {/* ── History Modal — ประวัติทุกการเปลี่ยนสถานะ (สร้าง→อนุมัติ→รับของ→คืน ฯลฯ) ── */}
      <Modal opened={historyOpened} onClose={closeHistory} title={
        <Group gap="xs">
          <IconHistory size={20} />
          <Text fw={600} style={{ fontFamily: 'Inter, sans-serif', fontSize: 18 }}>
            {t('handover.history', 'Handover History')} {historyTarget ? `HND-${String(historyTarget.id).padStart(4, '0')}` : ''}
          </Text>
        </Group>
      } size="lg" radius="lg">
        <ScrollArea h={480}>
          {loadingHistory ? (
            <Center p="xl"><Loader color="teal" /></Center>
          ) : historyData.length === 0 ? (
            <Center p="xl"><Text c="dimmed">{t('common.noHistory', 'ไม่มีประวัติ')}</Text></Center>
          ) : (
            <Timeline active={historyData.length} bulletSize={28} lineWidth={2} mt="sm">
              {historyData.map((h: any) => {
                const typeConfig: Record<string, { color: string; label: string; icon: string }> = {
                  HANDOVER:           { color: 'blue',   label: t('handover.hist.created', 'Request Created'),        icon: '📝' },
                  HANDOVER_APPROVED:  { color: 'teal',   label: t('handover.hist.approved', 'Approved'),              icon: '✅' },
                  HANDOVER_REJECTED:  { color: 'red',    label: t('handover.hist.rejected', 'Rejected by Approver'),  icon: '❌' },
                  HANDOVER_RECEIVED:  { color: 'green',  label: t('handover.hist.received', 'Received'),              icon: '📦' },
                  HANDOVER_DECLINED:  { color: 'orange', label: t('handover.hist.declined', 'Declined by Recipient'), icon: '🚫' },
                  HANDOVER_RETURN:    { color: 'lime',   label: t('handover.hist.returned', 'Returned'),              icon: '↩️' },
                  HANDOVER_CANCELLED: { color: 'gray',   label: t('handover.hist.cancelled', 'Cancelled'),            icon: '🗑️' },
                }
                const cfg = typeConfig[h.type] ?? { color: 'gray', label: h.type, icon: '•' }
                return (
                  <Timeline.Item
                    key={h.id}
                    bullet={<Text size="xs">{cfg.icon}</Text>}
                    title={
                      <Group gap={6}>
                        <Badge color={cfg.color} variant="light" size="sm">{cfg.label}</Badge>
                        <Text size="xs" c="dimmed">
                          {new Date(h.createdAt).toLocaleString(i18n.language === 'th' ? 'th-TH' : 'en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                        </Text>
                      </Group>
                    }
                  >
                    <Box mt={4}>
                      {h.performedBy && <Text size="xs" c="dimmed">{t('common.by', 'By')}: <b>{h.performedBy}</b></Text>}
                      {h.note && <Text size="xs" c="dimmed" mt={2}>{h.note}</Text>}
                    </Box>
                  </Timeline.Item>
                )
              })}
            </Timeline>
          )}
        </ScrollArea>
      </Modal>

      {/* ── Resend Confirmation Email Modal ── */}
      <Modal opened={resendOpened} onClose={closeResend} size="sm" radius="lg"
        title={<Text fw={600}>{t('handover.resendEmail', 'Resend Confirmation Email')}</Text>}>
        <Stack gap="sm">
          <Text size="sm" c="dimmed">
            {t('handover.resendHint', "Update the email address if it was wrong, then resend. A fresh link will be sent — the old link will no longer work.")}
          </Text>
          <TextInput
            label={t('common.email', 'Email')}
            placeholder="name@company.com"
            value={resendEmail}
            onChange={(e) => setResendEmail(e.target.value)}
          />
          <Group justify="flex-end" mt="sm">
            <Button variant="default" onClick={closeResend}>{t('common.cancel', 'Cancel')}</Button>
            <Button loading={resending} onClick={handleResendSubmit}
              style={{ background: 'var(--brand-primary, #0f172a)', color: 'var(--brand-on-primary, #fff)' }}>
              {t('handover.resendButton', 'Resend')}
            </Button>
          </Group>
        </Stack>
      </Modal>

      {/* ── Sign Receipt Modal ── */}
      <Modal opened={sigOpened} onClose={closeSig} size="md" radius="lg"
        title={
          <Group gap={8}>
            <IconCheck size={18} color="#0d9488" />
            <Text fw={600} style={{ fontFamily: 'Inter, sans-serif', fontSize: 18 }}>
              {t("handover.confirmAssetReceipt","Confirm Asset Receipt")}
            </Text>
          </Group>
        }
      >
        {selectedHandover && (
          <Stack gap="md">
            {/* Handover summary */}
            <Box style={{ background: '#f0fdf4', borderRadius: 10, padding: '10px 14px', border: '1px solid #bbf7d0' }}>
              <Text size="xs" fw={600} c="teal" mb={6} style={{ textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                Handover #{selectedHandover.id} — {selectedHandover.assets?.length ?? 0} item(s)
              </Text>
              {(selectedHandover.assets ?? []).map((a: any) => (
                <Group key={a.id} gap="sm" mb={4}>
                  {a.imageUrl && <Image src={a.imageUrl} w={32} h={32} radius="sm" fit="cover" />}
                  <Box>
                    <Text size="sm" fw={700}>{a.name}</Text>
                    <Text size="xs" c="dimmed">{a.assetCode} · {a.serialNumber}</Text>
                  </Box>
                </Group>
              ))}
            </Box>

            {/* Receiver info */}
            <Box style={{ background: '#f8fafc', borderRadius: 8, padding: '10px 14px' }}>
              <Group justify="space-between">
                <Box>
                  <Text size="xs" c="dimmed" style={{ textTransform: 'uppercase', letterSpacing: '0.3px' }}>{t('handover.receiver')}</Text>
                  <Text size="sm" fw={600}>{selectedHandover.toUser}</Text>
                  {selectedHandover.toPosition && <Text size="xs" c="dimmed">{selectedHandover.toPosition}</Text>}
                </Box>
                <Box style={{ textAlign: 'right' }}>
                  <Text size="xs" c="dimmed" style={{ textTransform: 'uppercase', letterSpacing: '0.3px' }}>{t("handover.receiptDate","Receipt Date")}</Text>
                  <Text size="sm" fw={600} c="teal">
                    {new Date().toLocaleDateString('th-TH', { day: '2-digit', month: 'short', year: 'numeric' })}
                  </Text>
                  <Text size="xs" c="dimmed">
                    {new Date().toLocaleTimeString('th-TH', { hour: '2-digit', minute: '2-digit' })} น.
                  </Text>
                </Box>
              </Group>
            </Box>

            <SignaturePad
              label="Receiver Signature — Please sign to acknowledge receipt"
              onSave={(sig) => setReceiveSig(sig)}
              value={receiveSig}
            />

            <Text size="xs" c="dimmed" style={{ fontStyle: 'italic' }}>
              By signing, you confirm receipt of the assets in good condition. Date and time will be recorded automatically.
            </Text>

            <Group justify="flex-end">
              <Button variant="default" onClick={closeSig}>{t("common.cancel","Cancel")}</Button>
              <Button
                loading={approving}
                disabled={!receiveSig}
                leftSection={<IconCheck size={16} />}
                onClick={handleReceiveSubmit}
                style={{ background: '#0d9488', color: '#ffffff', fontWeight: 500 }}
              >
                {t("handover.confirmReceipt","Confirm Receipt")}
              </Button>
            </Group>
          </Stack>
        )}
      </Modal>
      {/* ── Return Handover Modal ── */}
      <Modal opened={returnOpened} onClose={closeReturn}
        title={<Text fw={600} style={{ fontFamily: 'Inter, sans-serif', fontSize: 18 }}>{t('handover.returnHandover')}</Text>}
        size="xl" radius="lg" scrollAreaComponent={ScrollArea.Autosize}>
        <Stack gap="md">

          {/* Summary */}
          {returnTarget && (
            <Box style={{ background: '#e8f0ff', borderRadius: 10, padding: 12 }}>
              <Text size="sm" fw={700}>{t('handover.handoverNumber', 'Handover #{{id}}', { id: returnTarget.id })}</Text>
              <Text size="xs" c="dimmed">{t('handover.fromToLine', 'From: {{from}} → To: {{to}}', { from: returnTarget.fromUser, to: returnTarget.toUser })}</Text>
              <Text size="xs" c="dimmed">{t('handover.assetsWillReturnTo', '{{count}} asset(s) will be returned to {{name}} — set the condition for each item below.', { count: returnTarget.assets?.length ?? 0, name: returnTarget.fromUser })}</Text>
            </Box>
          )}

          <Divider label={t("handover.equipmentCondition","Equipment Condition")} labelPosition="left" />

          {/* Quick-apply condition — sets all items below at once, still editable individually */}
          <Box>
            <Text size="sm" fw={500} mb={4}>{t('handover.quickApplyAll', 'Quick set — apply to all items')}</Text>
            <Group gap="sm">
              {[
                { value: 'good', label: '✅ Good' },
                { value: 'repair', label: '🔧 Needs Repair' },
                { value: 'lost', label: '❓ Lost' },
              ].map(opt => (
                <Box key={opt.value} onClick={() => {
                  setReturnForm(p => ({ ...p, returnCondition: opt.value }))
                  setItemResults(p => p.map(r => ({ ...r, condition: opt.value })))
                  setNonAssetResults(p => p.map(r => ({ ...r, condition: opt.value })))
                }}
                  style={{
                    padding: '8px 16px', borderRadius: 8, cursor: 'pointer', border: '2px solid',
                    borderColor: returnForm.returnCondition === opt.value ? (opt.value === 'good' ? '#0d9488' : opt.value === 'repair' ? '#f59e0b' : '#ef4444') : '#e5e7eb',
                    background: returnForm.returnCondition === opt.value ? (opt.value === 'good' ? '#f8ffe0' : opt.value === 'repair' ? '#fffbeb' : '#fef2f2') : '#fafafa',
                    transition: 'all .15s',
                  }}>
                  <Text size="sm" fw={600}>{opt.label}</Text>
                </Box>
              ))}
            </Group>
            <Text size="xs" c="dimmed" mt={4}>{t('handover.quickApplyHint', 'Damaged items go through Repair for inspection — pick Needs Repair for those.')}</Text>
          </Box>

          {/* Per-item — always shown, this is what actually gets submitted */}
          <Box>
            <Text size="sm" fw={500} mb={8}>{t('handover.perItemCondition', 'Condition per item')}</Text>
            <Stack gap="xs" p="sm" style={{ background: '#f8fafc', borderRadius: 10, border: '1px solid #e2e8f0' }}>
              {itemResults.map((item, i) => (
                <Box key={item.assetId} style={{ background: '#fff', borderRadius: 8, padding: '8px 10px', border: '1px solid #e5e7eb' }}>
                  <Group justify="space-between" wrap="nowrap" mb={4}>
                    <Box style={{ minWidth: 0 }}>
                      <Text size="sm" fw={600} truncate>{item.name}</Text>
                      <Text size="xs" c="dimmed">{item.code}</Text>
                    </Box>
                    <Select
                      size="xs" w={130}
                      data={[
                        { value: 'good', label: `✅ ${t('handoverConfirm.good','Good')}` },
                        { value: 'repair', label: `🔧 ${t('assetStatus.repair','Repair')}` },
                        { value: 'lost', label: `❓ ${t('assetStatus.lost','Lost')}` },
                      ]}
                      value={item.condition}
                      onChange={(v) => setItemResults(p => p.map((r, j) => j === i ? { ...r, condition: v ?? 'good' } : r))}
                    />
                  </Group>
                  {item.condition !== 'good' && (
                    <TextInput size="xs" placeholder={t('handover.itemNotePlaceholder', 'Note for this item (optional)')}
                      value={item.note}
                      onChange={(e) => setItemResults(p => p.map((r, j) => j === i ? { ...r, note: e.target.value } : r))} />
                  )}
                </Box>
              ))}
              {nonAssetResults.map((item, i) => (
                <Box key={`na-${i}`} style={{ background: '#fff', borderRadius: 8, padding: '8px 10px', border: '1px solid #e5e7eb' }}>
                  <Group justify="space-between" wrap="nowrap" mb={4}>
                    <Box style={{ minWidth: 0 }}>
                      <Text size="sm" fw={600} truncate>{item.name}</Text>
                      <Text size="xs" c="dimmed">{t('handover.nonAssetItem', 'Not tracked as an Asset')}</Text>
                    </Box>
                    <Select
                      size="xs" w={130}
                      data={[
                        { value: 'good', label: `✅ ${t('handoverConfirm.good','Good')}` },
                        { value: 'repair', label: `🔧 ${t('assetStatus.repair','Repair')}` },
                        { value: 'lost', label: `❓ ${t('assetStatus.lost','Lost')}` },
                      ]}
                      value={item.condition}
                      onChange={(v) => setNonAssetResults(p => p.map((r, j) => j === i ? { ...r, condition: v ?? 'good' } : r))}
                    />
                  </Group>
                  {item.condition !== 'good' && (
                    <TextInput size="xs" placeholder={t('handover.itemNotePlaceholder', 'Note for this item (optional)')}
                      value={item.note}
                      onChange={(e) => setNonAssetResults(p => p.map((r, j) => j === i ? { ...r, note: e.target.value } : r))} />
                  )}
                </Box>
              ))}
              {itemResults.length === 0 && nonAssetResults.length === 0 && (
                <Text size="xs" c="dimmed">{t('common.noRecords', 'No records')}</Text>
              )}
            </Stack>
          </Box>

          {/* Return Photos */}
          <Box>
            <Text size="sm" fw={500} mb={2}>{t('handover.conditionPhotosReturn')}</Text>
            <Text size="xs" c="dimmed" mb={6}>{t('handover.returnPhotosHint', 'These photos capture the overall condition of everything returned together — not a separate photo per item.')}</Text>
            <Group gap="sm" wrap="wrap">
              {returnForm.returnPhotos.map((p, i) => (
                <Box key={i} style={{ position: 'relative' }}>
                  <Image src={p} w={88} h={68} radius="md" fit="cover" style={{ border: '1px solid #ebebeb' }} />
                  <ActionIcon size="xs" color="red" variant="filled" radius="xl"
                    style={{ position: 'absolute', top: -6, right: -6 }}
                    onClick={() => setReturnForm(prev => ({ ...prev, returnPhotos: prev.returnPhotos.filter((_, j) => j !== i) }))}>
                    <IconX size={10} />
                  </ActionIcon>
                </Box>
              ))}
              <FileButton onChange={addReturnPhoto} accept="image/*">
                {(props) => (
                  <Box {...props} w={88} h={68}
                    style={{ background: '#f8f7f4', borderRadius: 8, border: '1.5px dashed #ddd', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
                    <IconPhoto size={20} color="#bbb" />
                    <Text size="xs" c="dimmed">{t('handover.add')}</Text>
                  </Box>
                )}
              </FileButton>
            </Group>
          </Box>

          <Divider label={t("handover.receiverInformation","Receiver Information")} labelPosition="left" />

          {/* Receiver — locked to logged-in user */}
          <Box style={{ background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 8, padding: '12px 16px' }}>
            <Text size="xs" fw={600} c="teal" mb={6}>{t("handover.receiverAutoFilled","RECEIVER (AUTO-FILLED FROM YOUR ACCOUNT)")}</Text>
            <Group gap={32}>
              <Box>
                <Text size="xs" c="dimmed">{t("common.name","Name")}</Text>
                <Text size="sm" fw={600}>{fullName ?? username ?? '—'}</Text>
              </Box>
              <Box>
                <Text size="xs" c="dimmed">{t("common.position","Position")}</Text>
                <Text size="sm" fw={600}>{userPosition || <Text size="sm" c="dimmed" component="span">Not set — update in Profile</Text>}</Text>
              </Box>
            </Group>
            {!fullName && !username && (
              <Text size="xs" c="red" mt={4}>⚠️ Please re-login to load your account information</Text>
            )}
          </Box>

          {/* Return Location */}
          <Select
            label={t("handover.returnLocation","Return Location / Room *")}
            placeholder={t('handover.returnLocationPlaceholder')}
            data={locations.map((l: any) => ({ value: l.name, label: localizedName(l, i18n.language) }))}
            value={returnForm.returnLocation}
            onChange={(v) => setReturnForm(p => ({ ...p, returnLocation: v ?? '' }))}
            searchable clearable
          />

          {/* Accessories from original Handover */}
          {returnTarget?.accessories && (
            <Box style={{ background: '#f8fafc', borderRadius: 8, border: '1px solid #e2e8f0', padding: '10px 14px' }}>
              <Text size="xs" fw={600} c="dimmed" mb={4}>{t("handover.accessoriesFromHandover","ACCESSORIES FROM HANDOVER")}</Text>
              <Text size="sm">
                {parseAccessoriesFE(returnTarget.accessories).map((a: any) => `${a.name}${a.serialNumber ? ` (S/N: ${a.serialNumber})` : ''}`).join(' · ')}
              </Text>
            </Box>
          )}

          {/* Receiver Signature — compact */}
          <Box>
            <Text size="sm" fw={500} mb={6}>{t("handover.receiverSignature","Receiver Signature")}</Text>
            <Box style={{ maxWidth: 340 }}>
              <SignaturePad label="" value={returnSig} onSave={(sig) => {
                setReturnSig(sig)
                setReturnForm(p => ({ ...p, returnSignature: sig }))
              }} />
            </Box>
          </Box>

          <Divider label={t('handover.additionalNotes')} labelPosition="left" />

          <Textarea label={t("common.note","Remark")} placeholder={t("handover.anyRemarksPlaceholder","Any additional remarks...")} minRows={2}
            value={returnForm.returnNote}
            onChange={(e) => setReturnForm(p => ({ ...p, returnNote: e.target.value }))} />

          <Group justify="flex-end" mt="sm">
            <Button variant="default" onClick={closeReturn}>{t("common.cancel","Cancel")}</Button>
            <Button loading={returning} onClick={handleReturn} color="blue"
              leftSection={<IconArrowBack size={16} />}>
              {t("handover.confirmReturn","Confirm Return")}
            </Button>
          </Group>
        </Stack>
      </Modal>
      <AssetQuickView asset={qvAsset} opened={qvOpen} onClose={() => setQvOpen(false)} />
      <ImageLightbox
        images={lightbox?.images ?? []}
        initialIndex={lightbox?.index ?? 0}
        opened={lightbox !== null}
        onClose={closeLightbox}
      />

      {/* ── Edit Accessories Modal (RECEIVED) ── */}
      <Modal opened={accOpened} onClose={closeAccModal} size="md" radius="lg"
        title={
          <Box>
            <Text fw={600} style={{ fontFamily: 'Inter, sans-serif', fontSize: 16 }}>
              Edit Accessories — Handover #{accTarget?.id}
            </Text>
            <Text size="xs" c="dimmed">แก้ไขรายการ accessories และ note เท่านั้น — asset หลักและลายเซ็นไม่เปลี่ยน</Text>
          </Box>
        }>
        <Stack gap="md">
          {/* Asset picker */}
          <Select
            size="xs" searchable clearable
            label="เพิ่มจาก Asset List (Accessories)"
            placeholder={t("handover.searchAccessoryAssetPlaceholder","🔍 Search accessory asset...")}
            data={assets
              .filter((a: any) => a.category?.toLowerCase().includes('access'))
              .filter((a: any) => !accForm.accessories.some((acc: any) => acc.assetId === a.id))
              .map((a: any) => ({
                value: String(a.id),
                label: `${a.assetCode} — ${a.name}${a.serialNumber ? ` (${a.serialNumber})` : ''}`,
              }))}
            onChange={v => {
              if (!v) return
              const a = assets.find((x: any) => String(x.id) === v)
              if (!a) return
              setAccForm(p => ({
                ...p,
                accessories: [...p.accessories, { name: a.name, serialNumber: a.serialNumber ?? '', assetId: a.id }],
              }))
            }}
            value={null}
            nothingFoundMessage="ไม่พบ asset ใน Accessories category"
          />

          {/* Accessories list */}
          <Stack gap={6}>
            {accForm.accessories.map((acc: any, i: number) => (
              <Group key={i} gap="sm" align="center"
                style={{
                  background: acc.assetId ? '#f0fdf4' : '#f8fafc',
                  borderRadius: 8, padding: '8px 12px',
                  border: `1px solid ${acc.assetId ? '#0d9488' : '#e2e8f0'}`,
                }}>
                {acc.assetId && <Text size="xs" c="teal" fw={700} style={{ flexShrink: 0 }}>📦</Text>}
                <TextInput size="xs" placeholder={t("handover.itemNamePlaceholder","Item name")} style={{ flex: 2 }}
                  value={acc.name}
                  onChange={e => setAccForm(p => {
                    const list = [...p.accessories]; list[i] = { ...list[i], name: e.target.value }; return { ...p, accessories: list }
                  })} />
                <TextInput size="xs" placeholder={t("handover.snOptionalPlaceholder","S/N (optional)")} style={{ flex: 1.5 }}
                  value={acc.serialNumber ?? ''}
                  onChange={e => setAccForm(p => {
                    const list = [...p.accessories]; list[i] = { ...list[i], serialNumber: e.target.value }; return { ...p, accessories: list }
                  })} />
                <ActionIcon variant="subtle" color="teal" size="sm" disabled={!acc.assetId}
                  style={{ opacity: acc.assetId ? 1 : 0.3 }}
                  onClick={() => { if (!acc.assetId) return; setReplaceTargetIdx(i); setReplaceNewAssetId(null); setReplaceReason(''); setReplaceOpened(true) }}>
                  <IconRefresh size={13} />
                </ActionIcon>
                <ActionIcon variant="subtle" color="red" size="sm"
                  onClick={() => setAccForm(p => ({ ...p, accessories: p.accessories.filter((_, j) => j !== i) }))}>
                  <IconX size={13} />
                </ActionIcon>
              </Group>
            ))}
            <Button size="xs" variant="light" color="gray" leftSection={<IconPlus size={12} />}
              style={{ alignSelf: 'flex-start' }}
              onClick={() => setAccForm(p => ({ ...p, accessories: [...p.accessories, { name: '', serialNumber: '' }] }))}>
              + พิมพ์เพิ่มเอง
            </Button>
          </Stack>

          {/* Note */}
          <Textarea label={t('handover.remarksNote')} placeholder="เช่น 'Charger replaced — original damaged 28 Jun 2026'"
            minRows={2} value={accForm.note}
            onChange={e => setAccForm(p => ({ ...p, note: e.target.value }))} />

          <Group justify="flex-end">
            <Button variant="default" onClick={closeAccModal}>{t("common.cancel","Cancel")}</Button>
            <Button color="teal" loading={accSaving} onClick={handleSaveAccessories}
              leftSection={<IconCheck size={15} />}>
              {t("common.saveChanges","Save Changes")}
            </Button>
          </Group>
        </Stack>
      </Modal>

      {/* ── Replace Accessory Modal ── */}
      <Modal opened={replaceOpened} onClose={() => setReplaceOpened(false)} size="sm" radius="lg"
        title={<Text fw={600}>{t('handover.replaceAccessory', 'Replace Accessory')}</Text>}>
        <Stack gap="sm">
          {replaceTargetIdx !== null && (
            <Text size="sm" c="dimmed">
              {t('handover.replacingItem', 'Replacing: {{name}}', { name: accForm.accessories[replaceTargetIdx]?.name })}
            </Text>
          )}
          <Select
            label={t('handover.newReplacementAsset', 'New replacement asset')}
            searchable clearable
            placeholder={t("handover.searchAccessoryAssetPlaceholder","🔍 Search accessory asset...")}
            data={assets
              .filter((a: any) => a.category?.toLowerCase().includes('access'))
              .filter((a: any) => !accForm.accessories.some((acc: any) => acc.assetId === a.id))
              .map((a: any) => ({ value: String(a.id), label: `${a.assetCode} — ${a.name}${a.serialNumber ? ` (${a.serialNumber})` : ''}` }))}
            nothingFoundMessage="ไม่พบ asset ใน Accessories category"
            value={replaceNewAssetId}
            onChange={setReplaceNewAssetId}
          />
          <Textarea
            label={t('handover.replaceReasonLabel', 'Reason (e.g. old one broke)')}
            placeholder={t('handover.replaceReasonPlaceholder', 'e.g. Charger no longer works, replaced with a new one')}
            value={replaceReason}
            onChange={(e) => setReplaceReason(e.target.value)}
            minRows={2}
          />
          <Text size="xs" c="orange">
            ⚠️ {t('handover.replaceHint', 'The old item will be sent to Repair automatically using this reason.')}
          </Text>
          <Group justify="flex-end" mt="xs">
            <Button variant="default" onClick={() => setReplaceOpened(false)}>{t('common.cancel', 'Cancel')}</Button>
            <Button color="teal" disabled={!replaceNewAssetId}
              onClick={() => {
                if (replaceTargetIdx === null || !replaceNewAssetId) return
                const oldItem = accForm.accessories[replaceTargetIdx]
                const newAsset = assets.find((a: any) => String(a.id) === replaceNewAssetId)
                if (!newAsset) return
                setAccForm(p => {
                  const list = [...p.accessories]
                  list[replaceTargetIdx] = { name: newAsset.name, serialNumber: newAsset.serialNumber ?? '', assetId: newAsset.id }
                  return { ...p, accessories: list }
                })
                if (oldItem?.assetId) {
                  setReplacements(p => [...p, { oldAssetId: oldItem.assetId, oldName: oldItem.name, reason: replaceReason }])
                }
                setReplaceOpened(false)
              }}>
              {t('handover.confirmReplace', 'Replace')}
            </Button>
          </Group>
        </Stack>
      </Modal>
    </Box>
  )
}
